import React, { useEffect, useRef, useState } from 'react';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Container,
  Divider,
  FlexboxGrid,
  IconButton,
  Input,
  InputGroup,
  Panel,
  SelectPicker,
  Stack,
  Notification,
  Modal,
  CheckPicker,
  Drawer,
  Table,
  Whisper,
  Tooltip,
  Loader,
  Grid,
  Row,
  Pagination
} from 'rsuite';
import SortUpIcon from '@rsuite/icons/SortUp';
import SearchIcon from '@rsuite/icons/Search';
import globalIP, { IS_USE_ALIAS } from '@/GlobelIP';
import { useInView } from 'react-intersection-observer';
import ReviewPassIcon from '@rsuite/icons/ReviewPass';
import QrcodeIcon from '@rsuite/icons/Qrcode';
import jsPDF from 'jspdf';
import QRCode from 'qrcode-generator';
import axios from 'axios';
import { Icon } from '@rsuite/icons';
import ModalComponent from './CreateFairModal';
import CheckOutlineIcon from '@rsuite/icons/CheckOutline';
import ReactImageMagnify from 'react-image-magnify';
import TrashIcon from '@rsuite/icons/Trash';
import s1 from './template/QR1.jpg';
import s2 from './template/QR6.jpg';
import s3 from './template/QR7.jpg';
import s4 from './template/QR2.jpg';
import s11 from '../../../src/assets/images/items/s11.jpg';

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Navigation } from 'swiper/modules';
import ArrowLeftIcon from '@rsuite/icons/ArrowLeft';
import ArrowRightIcon from '@rsuite/icons/ArrowRight';
import useLabel from '@/clientWeb/hook/Label';
import { Link } from 'react-router-dom';
import ugr from '@/UGRoute';

const { Column, HeaderCell, Cell } = Table;
const data = ['Add to Bucket', 'Remove from bucket', 'View'].map(item => ({
  label: item,
  value: item
}));
const ManageFair = ({ page = '' }) => {
  const [fairname, setFairname] = useState([]);
  const [fairName, setFairName] = useState('');
  const [action, setAction] = useState('View');
  const [data123, setData123] = useState([]);
  const [limit, setLimit] = useState(0);
  const [meteData, setMeteData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCategoryCode, setSelectedCategoryCode] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState([]);
  const [selectedAlias, setSelectedAlias] = useState([]);
  const [selectedpron, setSelectedPron] = useState([]);
  const [selectedpd, setSelectedProd] = useState([]);
  const [selectedmade, setSelectedMade] = useState([]);
  const [selectedsku, setSelectedSku] = useState([]);
  const [selectedColor, setSelectedColor] = useState([]);
  const [selectedFinish, setSelectedFinish] = useState([]);
  const [selectedhsn, setSelectedhsn] = useState([]);
  const [selectedBuyer, setSelectedBuyer] = useState([]);
  const [selectedSearch, setSelectedSearch] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [productCode, setProductCode] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [disableUI, setDisableUI] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [openD, setOpenD] = useState(false);
  const [open, setOpen] = useState(false);
  const { ref, inView } = useInView({
    rootMargin: `0px 0px ${700}px 0px`
  });

  const [categorydata, setCategorydata] = useState([]);
  const [productypedata, setProductypedata] = useState([]);
  const [isLoadingpro, setIsLoadingpro] = useState(false);
  const [aliasdata, setAliasdata] = useState([]);
  const [isLoadingalias, setIsLoadinalias] = useState(false);
  const [proNamedata, setProdNamedata] = useState([]);
  const [isLoadingpron, setIsLoadingpron] = useState(false);
  const [skudata, setSkudata] = useState([]);
  const [isLoadingsku, setIsLoadinsku] = useState(false);
  const [buyernamedata, setBuyerNamedata] = useState([]);
  const [isLoadingbu, setIsLoadingbu] = useState(false);
  const [finishdata, setFinishdata] = useState([]);
  const [isLoadingfin, setIsLoadingfin] = useState(false);
  const [colordata, setColordata] = useState([]);
  const [isLoadingcolor, setIsLoadingcolor] = useState(false);
  const [searchdata, setSearchdata] = useState([]);
  const [isLoadingse, setIsLoadingse] = useState(false);
  const [proDdata, setProdDdata] = useState([]);
  const [isLoadingprod, setIsLoadingprod] = useState(false);
  const [madedata, setMadedata] = useState([]);
  const [isLoadingmade, setIsLoadingmade] = useState(false);
  const [hsndata, setHsndata] = useState([]);

  useEffect(() => {
    fetchDataFair();
  }, []);
  const fetchDataFair = async () => {
    const response = await fetch(
      `${globalIP}/api/fair-masters?populate=*&filters[fairstatus][$eq]=Active`
    );
    const json = await response.json();
    const processedData = json.data.map(item => ({
      label: item.attributes.fairName,
      value: item.attributes.fairCode
    }));
    setFairname(processedData.sort((a, b) => a.label.localeCompare(b.label)));
  };

  useEffect(() => {
    if (fairname) {
      fetchDatap();
    }
  }, [fairname]);

  const fetchDatap = async () => {
    // ✅ Fetch all in one call with large pageSize
    const response = await fetch(
      `${globalIP}/api/fair-product-masters?populate=*&filters[faircode][$eq]=${fairname[0]?.value}&pagination[pageSize]=10000`
    );
    const json = await response.json();
    const prdcdArray = json.data.map(item => item.attributes.prdcd);
    setProductCode(prdcdArray);
  };

  useEffect(() => {
    if (action === 'View') {
      setData123([]);
      setMeteData(null);
    }
  }, [action]);

  const [authst, setAuthst] = useState(true);

  const productCache = useRef(null);
  const allMatchingIds = useRef([]);
  const pageSize = 28;

  // ✅ Common reusable filter function
  const applyAllFilters = products => {
    let filtered = [...products];

    const checks = [
      [selectedCategoryCode, 'CategoryCode'],
      [selectedProductType, 'ProductTypeCode'],
      [selectedColor, 'ColorCode'],
      [selectedFinish, 'FinishCode'],
      [selectedhsn, 'HSNCode'],
      [selectedBuyer, 'BuyerName'],
      [selectedSearch, 'SearchKeyword'],
      [selectedpron, 'ProductName'],
      [selectedpd, 'ProductDesigner'],
      [selectedmade, 'MadeBy'],
      [selectedsku, 'BuyerSku']
    ];

    for (const [arr, key] of checks) {
      if (arr.length > 0) {
        filtered = filtered.filter(p => arr.includes(p.attributes[key]));
      }
    }

    // Alias filter
    if (selectedAlias.length > 0) {
      filtered = filtered.filter(p => {
        const id = p.attributes.ProductId?.toLowerCase() || '';
        return selectedAlias.some(alias => id.includes(alias.toLowerCase()));
      });
    }

    return filtered;
  };

  useEffect(() => {
    // Reset everything when action changes
    setCurrentPage(1);
    setData123([]);
    setSelectedRowIds([]);
    setMeteData(null);
  }, [action]);

  const handleSearch = value => {
    setSearchQuery(value);
  };
  const handleCheckboxChange = (rowId, checked) => {
    if (checked) {
      setSelectedRowIds(prevSelectedRowIds => [...prevSelectedRowIds, rowId]);
    } else {
      setSelectedRowIds(prevSelectedRowIds =>
        prevSelectedRowIds.filter(selectedRowId => selectedRowId !== rowId)
      );
    }
  };
  // const handleCheckAll = (value, checked) => {
  //   setSelectedRowIds(checked ? data123.map(item => item.id) : []);
  // };
  // const handleCheckAll = (value, checked) => {
  //   if (action === 'Remove from bucket') {
  //     setSelectedRowIds(checked ? allMatchingIds.current : []);
  //   } else if (action === 'Add to Bucket') {
  //     setSelectedRowIds(checked ? allMatchingIds.current : []);
  //   } else {
  //     setSelectedRowIds(checked ? allMatchingIds.current : []);
  //   }
  // };
  const handleCheckAll = (value, checked) => {
    if (!data123?.length) return; // safety check

    let idsToSelect = [];

    if (action === 'Remove from bucket') {
      // Select all fair-product-master IDs on current filtered data
      idsToSelect = data123.map(p => p.fairId).filter(Boolean);
    } else if (action === 'Add to Bucket') {
      // Select all product IDs on current filtered data
      idsToSelect = allFairIds;
    } else {
      // Default: use product IDs
      idsToSelect = data123.map(p => p.id).filter(Boolean);
    }

    setSelectedRowIds(checked ? idsToSelect : []);
  };

  const handleCheckAll2 = (value, checked) => {
    setSelectedRowIds(checked ? viewData.map(item => item.id) : []);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleCartClose = () => {
    setIsCartOpen(false);
  };
  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => {
    setCurrentPage(1); // ✅ Reset page
    setData123([]);
    setSelectedRowIds([]); // ✅ selection clear
    setOpen2(false);
    window.location.reload();
  };

  const cmToInch = value => (value / 2.54).toFixed(2);
  const inchToCm = value => (value * 2.54).toFixed(2);
  const [sizeUnit, setSizeUnit] = useState();
  const size = [
    { label: 'CM', value: 'cm' },
    { label: 'Inch', value: 'inch' }
  ];

  const fairmaster = `${globalIP}/api/fair-product-masters`;

  const submit = async (e, val) => {
    e.preventDefault();

    if (val === 0) {
      setIsLoading(true);

      try {
        // Map each selected ID to the product object from cache
        const selectedProductsData = selectedRowIds
          .map(id => data123.find(p => p.id === id))
          .filter(Boolean);
        // Create an array of fetch promises
        // 🔥 IMPORTANT FIX
        const idsToSubmit =
          selectedRowIds.length === allFairIds.length
            ? allFairIds // Select All case
            : selectedRowIds; // Normal selection

        const promises = idsToSubmit.map(async id => {
          const formData = new FormData();
          formData.append(
            'data',
            JSON.stringify({
              faircode: fairname.length > 0 ? fairname[0].value : '',
              fairname: fairname.length > 0 ? fairname[0].label : '',
              prdcd: String(id),
              // aliascd: product.attributes.ProductId,
              minCost: 0,
              avgCost: 0,
              maxCost: 0,
              currency: 'USD'
            })
          );

          const response = await fetch(fairmaster, {
            method: 'POST',
            body: formData
          });

          return response.json();
        });

        // Wait for all requests to complete
        await Promise.all(promises);

        setSelectedRowIds([]);
        handleOpen2();
      } catch (err) {
        console.error('Submit error:', err);
      } finally {
        setIsLoading(false);
      }
    } else {
      setOpenq(true);
    }
  };

  const submitwithqr = async () => {
    try {
      setIsLoading(true);

      const fairCode = fairname?.[0]?.value || '';
      const fairLabel = fairname?.[0]?.label || '';

      // 🔥 If Select All active → use allFairIds
      const idsToSubmit = selectedRowIds.length === allFairIds.length ? allFairIds : selectedRowIds;

      const promises = idsToSubmit.map(async id => {
        const formData = new FormData();

        formData.append(
          'data',
          JSON.stringify({
            faircode: fairCode,
            fairname: fairLabel,
            prdcd: String(id),
            // aliascd: String(id), // if alias is same as id
            minCost: 0,
            avgCost: 0,
            maxCost: 0,
            currency: 'USD'
          })
        );

        const response = await fetch(fairmaster, {
          method: 'POST',
          body: formData
        });

        return response.json();
      });

      await Promise.all(promises);

      handleOpen2();
      setOpenq(false);
      setSelectedRowIds([]);
    } catch (error) {
      console.error('Submit with QR error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  //// QR CODE ////
  const [data1, setData1] = useState([]);
  useEffect(() => {
    fetchDatacd();
  }, []);
  const fetchDatacd = async () => {
    const response = await fetch(`${globalIP}/api/company-details?populate=*`);
    const json = await response.json();
    setAuthst(json.data[0]?.attributes.Authorised);
    setData1(json.data);
  };
  const loadImageDimensions = url => {
    return new Promise(resolve => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.src = url;
    });
  };
  const loadImageSafe = async url => {
    try {
      const dimensions = await loadImageDimensions(url);
      return dimensions;
    } catch (error) {
      console.error(`Failed to load image from URL: ${url}`, error);
      return null; // Return null if the image fails to load
    }
  };
  const [isQRLoading1, setIsQRLoading1] = useState(false);
  const [isQRLoading2, setIsQRLoading2] = useState(false);
  const [isQRLoading3, setIsQRLoading3] = useState(false);
  const [isQRLoading4, setIsQRLoading4] = useState(false);
  const [isQRLoading5, setIsQRLoading5] = useState(false);
  const [isQRLoading6, setIsQRLoading6] = useState(false);
  const [isQRLoading7, setIsQRLoading7] = useState(false);
  const handleDownloadQR = async productData => {
    setIsQRLoading1(true);
    // console.log(productData)
    const pdf = new jsPDF();
    const logoUrl = data1.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
    const img = `${globalIP}${logoUrl}`;
    const boxWidth = 99;
    const boxHeight = 56;
    const boxesPerRow = 2; // Number of boxes per row
    const maxBoxesPerPage = 10;
    // Iterate over each product in productData
    // if (productData.length === 0) {
    //   alert('No rows selected for export QR Code2!');
    //   return;
    // }
    for (const [index, product] of productData.entries()) {
      if (index % maxBoxesPerPage === 0 && index !== 0) {
        pdf.addPage();
      }
      const relativeIndex = index % maxBoxesPerPage;
      const row = Math.floor(relativeIndex / boxesPerRow);
      const col = relativeIndex % boxesPerRow;
      // Calculate the starting point of each box based on row and column
      const boxX = 2 + col * (boxWidth + 2); // 5 is the horizontal margin between boxes
      const boxY = 3 + row * (boxHeight + 3); // 5 is the vertical margin between boxes
      // Draw a box for each product
      pdf.rect(boxX, boxY, boxWidth, boxHeight);
      // Define the box properties for the logo within each box
      // const logoWidth = 22; // Adjust the logo width as needed
      // const logoHeight = 7; // Adjust the logo height as needed
      // const logoX = 6 + boxX; // Adjust the X position as needed
      // const logoY = 1 + boxY; // Adjust the Y position as needed
      const logoXi = 55 + boxX; // Adjust the X position as needed
      const logoYi = 7 + boxY; // Adjust the Y position as needed
      // Add the logo to the PDF within each box
      const img1 = product.image;
      if (img1) {
        const imgp = img1 ? `${globalIP}${img1}` : '';
        const productImageDimensions = await loadImageDimensions(imgp);
        const maxImageWidth = 30; // Adjust to fit the container
        const maxImageHeight = 30;

        let productImageWidth = productImageDimensions.width;
        let productImageHeight = productImageDimensions.height;

        const widthRatio = maxImageWidth / productImageWidth;
        const heightRatio = maxImageHeight / productImageHeight;
        const scaleRatio = Math.min(widthRatio, heightRatio);

        if (scaleRatio < 1) {
          productImageWidth *= scaleRatio;
          productImageHeight *= scaleRatio;
        }

        // Center the image within the container
        const centeredX = 55 + boxX + (maxImageWidth - productImageWidth) / 2;
        const centeredY = 7 + boxY + (maxImageHeight - productImageHeight) / 2;

        pdf.addImage(imgp, 'JPEG', centeredX, centeredY, productImageWidth, productImageHeight);
      }

      // Add the logo with similar scaling and positioning logic
      const logoDimensions = await loadImageDimensions(img);
      const maxLogoWidth = 22;
      const maxLogoHeight = 7;

      let logoWidth = logoDimensions.width;
      let logoHeight = logoDimensions.height;

      const logoWidthRatio = maxLogoWidth / logoWidth;
      const logoHeightRatio = maxLogoHeight / logoHeight;
      const logoScaleRatio = Math.min(logoWidthRatio, logoHeightRatio);

      if (logoScaleRatio < 1) {
        logoWidth *= logoScaleRatio;
        logoHeight *= logoScaleRatio;
      }

      const logoX = 6 + boxX + (maxLogoWidth - logoWidth) / 2;
      const logoY = 1 + boxY + (maxLogoHeight - logoHeight) / 2;

      pdf.setFont('sans-serif', 'bold');
      pdf.setFontSize(8);
      pdf.text('Tag Code :', 6 + boxX, 44 + boxY);
      pdf.text('Name :', 6 + boxX, 48 + boxY);
      pdf.setFont('sans-serif', 'normal');
      pdf.setFontSize(8);
      pdf.text(`${product?.attributes?.ProductId || product?.pcode}`, 22 + boxX, 44 + boxY); // Adjust X position to place the value after the label
      pdf.text(`${product?.attributes?.ProductName || product?.name}`, 16 + boxX, 48 + boxY);
      const qrCode = QRCode(0, 'L');
      let qrValue;

      if (IS_USE_ALIAS) {
        qrValue = product?.code;
      } else {
        qrValue =
          product?.pcode || product?.attributes?.ProductId || product?.attributes?.Variant_Id;
      }

      // const qrValue =
      //   product?.attributes?.ProductId || product?.pcode || product?.attributes?.Variant_Id;

      if (!qrValue) {
        console.warn('QR value missing for product:', product);
        return; // skip this product
      }

      qrCode.addData(String(qrValue ?? ''));
      qrCode.make();
      const qrCodeImage = qrCode.createDataURL();
      const qrCodeWidth = 38;
      const qrCodeHeight = 35;
      pdf.addImage(qrCodeImage, 'JPEG', 2 + boxX, boxY + 5.7, qrCodeWidth, qrCodeHeight);
      pdf.addImage(img, 'JPEG', logoX, logoY + 0.5, logoWidth, logoHeight);
      pdf.setFont('sans-serif', 'bold');
      pdf.setFontSize(8);
      pdf.text('Grs Wt :', 55 + boxX, 44 + boxY);
      pdf.text('Net Wt :', 74 + boxX, 44 + boxY);

      pdf.setFont('sans-serif', 'normal');
      pdf.setFontSize(8);
      pdf.text(`${product?.attributes?.GrossWeight || product?.grwt}`, 67 + boxX, 44 + boxY);
      pdf.text(`${product?.attributes?.NetWeight || product?.ntwt}`, 86 + boxX, 44 + boxY);

      pdf.setFont('sans-serif', 'italic', 'bold');
      pdf.text('Powered By :', 6 + boxX, 53 + boxY);
      pdf.setTextColor(24, 61, 104);
      pdf.setFontSize(8);
      pdf.text('ERPDaddy Software Solution(P) Ltd.', 23 + boxX, 53 + boxY);
      pdf.setTextColor(0, 0, 0);
    }
    pdf.save('QRPrint.pdf');
    setIsQRLoading1(false);
  };
  const handleDownloadQRDS1 = async (productData, data1) => {
    setIsQRLoading7(true);
    console.log(productData, data1);
    const logoUrl = data1.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
    const img = `${globalIP}${logoUrl}`;
    const pdf = new jsPDF('portrait', 'mm', 'a4');

    const stickerW = 65;
    const stickerH = 32;

    const marginX = 2;
    const marginY = 5;
    const gapX = 2;
    const gapY = 3;

    const perRow = 3;
    const perPage = 24;

    // --------------------
    // ✅ SIZE CONVERSION HELPER FUNCTION
    // --------------------
    const getSizeInBothUnits = (sizeStr, sizeUnit, length, width, height) => {
      // Try to build size from Length x Width x Height if sizeStr is empty
      if (!sizeStr && length && width && height) {
        sizeStr = `${length} x ${width} x ${height}`;
      }

      if (!sizeStr) return { cm: '', inches: '' };

      const lowerStr = String(sizeStr).toLowerCase();

      // Detect unit from string or use sizeUnit parameter
      let isInches =
        lowerStr.includes('inch') || lowerStr.includes('"') || lowerStr.includes(' in');
      let isCm = lowerStr.includes('cm');

      // If no unit in string, use sizeUnit parameter (from new structure)
      if (!isInches && !isCm && sizeUnit) {
        const unitLower = String(sizeUnit).toLowerCase();
        if (unitLower.includes('inch') || unitLower.includes('in')) {
          isInches = true;
        } else if (unitLower.includes('cm')) {
          isCm = true;
        }
      }

      // Extract numeric values
      let cleaned = String(sizeStr)
        .toLowerCase()
        .replace(/\s*cm\s*/g, '')
        .replace(/\s*inch(es)?\s*/g, '')
        .replace(/\s*in\s*/g, '')
        .replace(/"/g, '')
        .trim();

      const dimensions = cleaned
        .split(/\s*x\s*/i)
        .map(dim => parseFloat(dim.trim()))
        .filter(num => !isNaN(num));

      if (dimensions.length === 0) return { cm: '', inches: '' };

      let cmValues, inchValues;

      if (isInches) {
        // Input is in inches -> convert to cm
        inchValues = dimensions.map(d => d.toFixed(1));
        cmValues = dimensions.map(d => (d * 2.54).toFixed(1));
      } else {
        // Input is in cm (or no unit, assume cm) -> convert to inches
        cmValues = dimensions.map(d => d.toFixed(1));
        inchValues = dimensions.map(d => (d * 0.393701).toFixed(1));
      }

      return {
        cm: cmValues.join(' x '),
        inches: inchValues.join(' x ')
      };
    };

    if (!Array.isArray(productData) || productData.length === 0) {
      console.warn('productData is not a valid array');
      return;
    }

    for (let i = 0; i < productData.length; i++) {
      if (i !== 0 && i % perPage === 0) {
        pdf.addPage();
      }

      const index = i % perPage;
      const row = Math.floor(index / perRow);
      const col = index % perRow;

      const x = marginX + col * (stickerW + gapX);
      const y = marginY + row * (stickerH + gapY);

      const p = productData[i];

      // Sticker border
      pdf.rect(x, y, stickerW, stickerH);

      // --------------------
      // LOGO AT TOP - Dynamic Image
      // --------------------
      if (img && logoUrl) {
        const logoWidth = 20;
        const logoHeight = 5;
        const logoX = x + (stickerW - logoWidth) / 2;
        const logoY = y + 1.5;

        pdf.addImage(img, 'PNG', logoX, logoY, logoWidth, logoHeight);
      }

      // Reset text color to black
      pdf.setTextColor(0, 0, 0);

      // --------------------
      // PRODUCT IMAGE (Left side)
      // --------------------
      const imgX = x + 2;
      const imgY = y + 7;
      const imgMaxW = 24;
      const imgMaxH = 14;

      // --------------------
      // PRODUCT IMAGE (Supports Old + New Structure)
      // --------------------

      let imagePath = null;

      // ✅ Old structure support
      if (p.image) {
        imagePath = p.image;
      }

      // ✅ New Strapi structure support
      if (!imagePath) {
        imagePath =
          p?.attributes?.CoverImage?.data?.attributes?.formats?.small?.url ||
          p?.attributes?.CoverImage?.data?.attributes?.url ||
          null;
      }

      if (imagePath) {
        const imgUrl = imagePath.startsWith('http') ? imagePath : `${globalIP}${imagePath}`;

        try {
          const dim = await loadImageDimensions(imgUrl);

          let w = dim.width;
          let h = dim.height;

          const scale = Math.min(imgMaxW / w, imgMaxH / h);
          w *= scale;
          h *= scale;

          const imgXAligned = x + 2;
          const imgYCentered = imgY + (imgMaxH - h) / 2;

          pdf.addImage(imgUrl, 'JPEG', imgXAligned, imgYCentered, w, h);
        } catch (err) {
          console.warn('Image load failed:', imgUrl);
        }
      }

      // --------------------
      // QR CODE (Right side)
      // --------------------
      const qr = QRCode(0, 'L');

      // ✅ Extract code from both old and new structure
      let qrValue;

      if (IS_USE_ALIAS) {
        qrValue = p?.code;
      } else {
        qrValue = p?.pcode || p?.attributes?.ProductId || p?.attributes?.Variant_Id;
      }
      // const productCode = p.code || p?.attributes?.ProductId || '';
      qr.addData(String(qrValue));
      qr.make();

      const sizeX = x + stickerW - 22;

      const qrSize = 18;
      const qrX = sizeX - 1;
      const qrY = y + 5;

      pdf.addImage(qr.createDataURL(), 'JPEG', qrX, qrY, qrSize, qrSize);

      // --------------------
      // ✅ EXTRACT SIZE DATA FROM BOTH STRUCTURES
      // --------------------

      // Old structure
      let sizeStr = p.size || null;
      let sizeUnit = null;
      let length = null;
      let width = null;
      let height = null;

      // New structure
      if (!sizeStr && p.attributes) {
        sizeUnit = p.attributes.SizeUnit || null;
        length = p.attributes.Length || null;
        width = p.attributes.Width || null;
        height = p.attributes.Height || null;
      }

      // Get sizes in both units
      const { cm: sizeCm, inches: sizeInches } = getSizeInBothUnits(
        sizeStr,
        sizeUnit,
        length,
        width,
        height
      );

      // --------------------
      // PRODUCT DETAILS (Bottom left, below image)
      // --------------------
      pdf.setFontSize(6);
      pdf.setFont('helvetica', 'bold');

      const textY = y + 23.5;
      const sizeXAdjusted = sizeX - 9;

      // Calculate available width for text
      const maxTextWidth = sizeXAdjusted - x - 4;

      // ✅ Extract product code and name from both structures
      const displayCode = p.code || p?.attributes?.ProductId || 'N/A';
      const displayName = p.name || p?.attributes?.ProductName || 'Product';

      // Style No
      pdf.text(`Style No : ${displayCode}`, x + 2, textY, { maxWidth: maxTextWidth });

      // Name with wrapping
      const nameText = `Name : ${displayName}`;
      const nameLines = pdf.splitTextToSize(nameText, maxTextWidth);

      // Print name - if it wraps, it will take multiple lines
      let currentY = textY + 2.5;
      nameLines.forEach((line, index) => {
        pdf.text(line, x + 2, currentY + index * 2.5);
      });

      // Size info on the right side
      pdf.setFontSize(5.5);

      pdf.text(`Size ( cms ) :`, sizeXAdjusted, textY);
      pdf.text(`${sizeCm}`, sizeXAdjusted + 12, textY);

      pdf.text(`Size ( Inchs ) :`, sizeXAdjusted, textY + 2.5);
      pdf.text(`${sizeInches}`, sizeXAdjusted + 12, textY + 2.5);
    }

    pdf.save('Product_QR_Sticker.pdf');
    setIsQRLoading7(false);
  };
  // const handleDownloadQRDS1 = async (productData, data1) => {
  //   console.log(productData, data1);
  //   const logoUrl = data1.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
  //   const img = `${globalIP}${logoUrl}`;
  //   const pdf = new jsPDF('portrait', 'mm', 'a4');

  //   const stickerW = 65;
  //   const stickerH = 32;

  //   const marginX = 2;
  //   const marginY = 5;
  //   const gapX = 2;
  //   const gapY = 3;

  //   const perRow = 3;
  //   const perPage = 30;
  //   if (!Array.isArray(productData) || productData.length === 0) {
  //     console.warn('productData is not a valid array');
  //     return;
  //   }
  //   for (let i = 0; i < productData.length; i++) {
  //     if (i !== 0 && i % perPage === 0) {
  //       pdf.addPage();
  //     }

  //     const index = i % perPage;
  //     const row = Math.floor(index / perRow);
  //     const col = index % perRow;

  //     const x = marginX + col * (stickerW + gapX);
  //     const y = marginY + row * (stickerH + gapY);

  //     const p = productData[i];

  //     // Sticker border
  //     pdf.rect(x, y, stickerW, stickerH);

  //     // --------------------
  //     // LOGO AT TOP - Dynamic Image
  //     // --------------------
  //     if (img && logoUrl) {
  //       const logoWidth = 20; // Adjust width as needed
  //       const logoHeight = 5; // Adjust height as needed
  //       const logoX = x + (stickerW - logoWidth) / 2; // Center horizontally
  //       const logoY = y + 1.5; // Position from top

  //       pdf.addImage(img, 'PNG', logoX, logoY, logoWidth, logoHeight);
  //     }

  //     // Reset text color to black
  //     pdf.setTextColor(0, 0, 0);

  //     // --------------------
  //     // PRODUCT IMAGE (Left side)
  //     // --------------------
  //     const imgX = x + 2;
  //     const imgY = y + 7;
  //     const imgMaxW = 24;
  //     const imgMaxH = 14;

  //     // --------------------
  //     // PRODUCT IMAGE (Supports Old + New Structure)
  //     // --------------------

  //     let imagePath = null;

  //     // ✅ Old structure support
  //     if (p.image) {
  //       imagePath = p.image;
  //     }

  //     // ✅ New Strapi structure support
  //     if (!imagePath) {
  //       imagePath =
  //         p?.attributes?.CoverImage?.data?.attributes?.formats?.small?.url ||
  //         p?.attributes?.CoverImage?.data?.attributes?.url ||
  //         null;
  //     }

  //     if (imagePath) {
  //       const imgUrl = imagePath.startsWith('http') ? imagePath : `${globalIP}${imagePath}`;

  //       try {
  //         const dim = await loadImageDimensions(imgUrl);

  //         let w = dim.width;
  //         let h = dim.height;

  //         const scale = Math.min(imgMaxW / w, imgMaxH / h);
  //         w *= scale;
  //         h *= scale;

  //         const imgXAligned = x + 2;
  //         const imgYCentered = imgY + (imgMaxH - h) / 2;

  //         pdf.addImage(imgUrl, 'JPEG', imgXAligned, imgYCentered, w, h);
  //       } catch (err) {
  //         console.warn('Image load failed:', imgUrl);
  //       }
  //     }

  //     // --------------------
  //     // QR CODE (Right side) - MOVED UP
  //     // --------------------
  //     const qr = QRCode(0, 'L');
  //     qr.addData(String(p.code || ''));
  //     qr.make();

  //     // Define sizeX first so we can align QR with it
  //     const sizeX = x + stickerW - 22;

  //     const qrSize = 18;
  //     const qrX = sizeX - 1;
  //     const qrY = y + 5;

  //     pdf.addImage(qr.createDataURL(), 'JPEG', qrX, qrY, qrSize, qrSize);

  //     // --------------------
  //     // Convert size to inches
  //     // --------------------
  //     const convertToInches = sizeCm => {
  //       if (!sizeCm) return '';

  //       const dimensions = sizeCm.replace(' cm', '').split('x');
  //       const inchDimensions = dimensions.map(dim => {
  //         const inches = parseFloat(dim) * 0.393701;
  //         return inches.toFixed(1);
  //       });

  //       return inchDimensions.join('x');
  //     };

  //     // Extract only numeric values (remove "cm")
  //     const extractNumericSize = sizeCm => {
  //       if (!sizeCm) return '';
  //       return sizeCm.replace(' cm', ''); // Remove " cm" to get only numbers
  //     };

  //     // --------------------
  //     // PRODUCT DETAILS (Bottom left, below image)
  //     // --------------------
  //     pdf.setFontSize(6);
  //     pdf.setFont('helvetica', 'bold');

  //     const textY = y + 23.5;
  //     const sizeXAdjusted = sizeX - 5;

  //     // Calculate available width for text (left text area, not overlapping with size section)
  //     const maxTextWidth = sizeXAdjusted - x - 4; // Width from left margin to size section

  //     // Style No
  //     pdf.text(`Style No : ${p.code || 'AH-L-0404'}`, x + 2, textY, { maxWidth: maxTextWidth });

  //     // Name with wrapping
  //     const nameText = `Name : ${p.name || 'Table'}`;
  //     const nameLines = pdf.splitTextToSize(nameText, maxTextWidth);

  //     // Print name - if it wraps, it will take multiple lines
  //     let currentY = textY + 2.5;
  //     nameLines.forEach((line, index) => {
  //       pdf.text(line, x + 2, currentY + index * 2.5);
  //     });

  //     // Size info on the right side - moved left to fit in container
  //     pdf.setFontSize(5.5); // Slightly smaller for size text

  //     pdf.text(`Size ( cms ) :`, sizeXAdjusted, textY);
  //     pdf.text(`${extractNumericSize(p.size)}`, sizeXAdjusted + 12, textY); // Only numbers, no "cm"

  //     pdf.text(`Size ( Inchs ) :`, sizeXAdjusted, textY + 2.5);
  //     pdf.text(`${convertToInches(p.size)}`, sizeXAdjusted + 12, textY + 2.5); // Only numbers, no "inch"
  //   }

  //   pdf.save('Product_QR_Sticker.pdf');
  // };
  // const handleDownloadQRDS1 = async productData => {
  //   const pdf = new jsPDF('portrait', 'mm', 'a4');

  //   const stickerW = 58; // was 55 → slightly wider
  //   const stickerH = 30; // was 28 → slightly taller

  //   const marginX = 2;
  //   const marginY = 5;
  //   const gapX = 1;
  //   const gapY = 3;

  //   const perRow = 4;
  //   const perPage = 40;

  //   for (let i = 0; i < productData.length; i++) {
  //     if (i !== 0 && i % perPage === 0) {
  //       pdf.addPage();
  //     }

  //     const index = i % perPage;
  //     const row = Math.floor(index / perRow);
  //     const col = index % perRow;

  //     const x = marginX + col * (stickerW + gapX);
  //     const y = marginY + row * (stickerH + gapY);

  //     const p = productData[i];

  //     // Sticker border
  //     pdf.rect(x, y, stickerW, stickerH);

  //     // --------------------
  //     // QR CODE (Top Left) - increased size
  //     // --------------------
  //     const qr = QRCode(0, 'L');
  //     qr.addData(p.pcode || p.code);
  //     qr.make();

  //     const qrSize = 18; // increased from 14 → 18

  //     pdf.addImage(qr.createDataURL(), 'JPEG', x + 1, y + 2, qrSize, qrSize);

  //     // --------------------
  //     // TEXT (Below QR)
  //     // --------------------
  //     pdf.setFontSize(6);
  //     pdf.setFont('helvetica', 'normal');

  //     pdf.text(`Name : ${p.name || '-'}`, x + 2, y + qrSize + 4);
  //     pdf.text(`Style No : ${p.code || '-'}`, x + 2, y + qrSize + 7);
  //     pdf.text(`Size : ${p.size || '-'}`, x + 2, y + qrSize + 10);

  //     // --------------------
  //     // PRODUCT IMAGE (Right)
  //     // --------------------
  //     if (p.image) {
  //       const imgUrl = `${globalIP}${p.image}`;
  //       const dim = await loadImageDimensions(imgUrl);

  //       let w = dim.width;
  //       let h = dim.height;

  //       const maxW = 20;
  //       const maxH = 22;

  //       const scale = Math.min(maxW / w, maxH / h);
  //       w *= scale;
  //       h *= scale;

  //       const imgX = x + stickerW - w - 2;
  //       const imgY = y + 2;

  //       pdf.addImage(imgUrl, 'JPEG', imgX, imgY, w, h);
  //     }
  //   }

  //   pdf.save('Product_QR_Sticker.pdf');
  // };

  const handleDownloadQR2 = productData => {
    setIsQRLoading2(true);
    const pdf = new jsPDF();
    const logoUrl = data1.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
    const img = `${globalIP}${logoUrl}`;
    const boxWidth = 51;
    const boxHeight = 60;
    const boxesPerRow = 4; // Number of boxes per row
    const maxBoxesPerPage = 16;

    // Load the logo image and calculate its natural dimensions
    const logoImage = new Image();
    logoImage.src = img;

    logoImage.onload = function () {
      const logoWidthRatio = 25; // Target width for the logo in the box
      const logoHeightRatio = 7; // Target height for the logo in the box

      // Calculate natural aspect ratio
      const aspectRatio = logoImage.width / logoImage.height;

      // Adjust the width and height based on the aspect ratio to fit the target area
      let logoWidthAdjusted = logoWidthRatio;
      let logoHeightAdjusted = logoWidthAdjusted / aspectRatio;

      if (logoHeightAdjusted > logoHeightRatio) {
        logoHeightAdjusted = logoHeightRatio;
        logoWidthAdjusted = logoHeightAdjusted * aspectRatio;
      }

      // Iterate over each product in productData
      productData.forEach((product, index) => {
        if (index % maxBoxesPerPage === 0 && index !== 0) {
          pdf.addPage();
        }
        const relativeIndex = index % maxBoxesPerPage;
        const row = Math.floor(relativeIndex / boxesPerRow);
        const col = relativeIndex % boxesPerRow;

        const boxX = 1 + col * (boxWidth + 1);
        const boxY = 1 + row * (boxHeight + 1);

        pdf.rect(boxX, boxY, boxWidth, boxHeight);

        // Add the resized logo to the PDF
        const logoX = 22 + boxX;
        const logoY = 2 + boxY;
        pdf.addImage(img, 'JPEG', logoX, logoY, logoWidthAdjusted, logoHeightAdjusted);

        const qrCode = QRCode(0, 'L');

        let qrValue;

        if (IS_USE_ALIAS) {
          qrValue = product?.code;
        } else {
          qrValue =
            product?.pcode || product?.attributes?.ProductId || product?.attributes?.Variant_Id;
        }
        // const qrValue =
        //   product?.attributes?.ProductId || product?.pcode || product?.attributes?.Variant_Id;

        if (!qrValue) {
          console.warn('QR value missing for product:', product);
          return; // skip this product
        }

        qrCode.addData(qrValue);
        qrCode.make();
        const qrCodeImage = qrCode.createDataURL();
        const qrCodeWidth = 40;
        const qrCodeHeight = 40;
        pdf.addImage(qrCodeImage, 'JPEG', 5.5 + boxX, boxY + 9, qrCodeWidth, qrCodeHeight);

        pdf.setFontSize(10);
        pdf.text(`Code : ${qrValue || product?.pcode}`, 15.5 + boxX, 48 + boxY);
        pdf.text('Powered By', 15.5 + boxX, 53 + boxY);
        pdf.setTextColor(46, 120, 204);
        pdf.setFontSize(8);
        pdf.text('ERPDADDY Software Solution(p) Ltd.', 2 + boxX, 58 + boxY);
        pdf.setTextColor(0, 0, 0);
      });

      pdf.save('QRPrint.pdf');
      setIsQRLoading2(false);
    };
  };

  const handleDownloadQR3 = async (productData, data1) => {
    setIsQRLoading3(true);
    const pdf = new jsPDF({ unit: 'mm', format: 'a4' });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 1;

    const logoUrl = data1?.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
    const img = logoUrl ? `${globalIP}${logoUrl}` : null;

    if (productData.length === 0) {
      alert('No rows selected for export QR Code!');
      return;
    }

    let logoBase64 = null;
    if (img) {
      logoBase64 = await loadImageAsBase64(img);
    }

    const blockSpacing = 4; // mm spacing between blocks
    const spacing = 1.5; // mm vertical spacing between logo, QR, and text
    const textAreaHeight = 4; // mm height for text area
    const borderPadding = 1.5; // padding inside border

    let x = margin;
    let y = margin;

    for (let i = 0; i < productData.length; i++) {
      const product = productData[i];

      // Max logo size reduced to fit block
      let actualLogoWidth = 0;
      let actualLogoHeight = 0;
      if (logoBase64) {
        const logoDimensions = await loadImageSafe(img);
        if (logoDimensions) {
          let logoWidth = logoDimensions.width;
          let logoHeight = logoDimensions.height;

          const maxLogoWidth = 30; // max width in mm (~2 cm)
          const maxLogoHeight = 5; // max height in mm

          const scale = Math.min(maxLogoWidth / logoWidth, maxLogoHeight / logoHeight, 1);
          actualLogoWidth = logoWidth * scale;
          actualLogoHeight = logoHeight * scale;
        }
      }

      const qrCodeSize = 24; // 20 mm = 2 cm

      // Calculate total content width and height for border
      const originalContentWidth = Math.max(actualLogoWidth, qrCodeSize) + borderPadding * 2;
      const extraWidth = 2.5; // your requested width increase
      const contentWidth = originalContentWidth + extraWidth;
      const bottomTrim = 2; // Reduce border height from bottom
      const contentHeight =
        actualLogoHeight +
        spacing +
        qrCodeSize +
        spacing +
        textAreaHeight +
        borderPadding * 2 -
        bottomTrim;

      // Check for horizontal page break
      if (x + contentWidth + margin > pageWidth) {
        x = margin;
        y += contentHeight + blockSpacing;
      }

      // Check for vertical page break
      if (y + contentHeight + margin > pageHeight) {
        pdf.addPage();
        x = margin;
        y = margin;
      }

      // Draw border around content
      pdf.setDrawColor(0);
      pdf.setLineWidth(0.3);
      pdf.rect(x, y, contentWidth, contentHeight);

      // Draw logo centered inside border with padding
      if (logoBase64 && actualLogoHeight > 0) {
        const logoX = x + (contentWidth - actualLogoWidth) / 2;
        const logoY = y + borderPadding;
        pdf.addImage(logoBase64, 'PNG', logoX, logoY, actualLogoWidth, actualLogoHeight);
      }

      // Draw QR code below logo
      const qrX = x + (contentWidth - qrCodeSize) / 2;
      const qrY = y + borderPadding + actualLogoHeight + spacing;

      const qrCode = QRCode(0, 'L');
      let qrValue;

      if (IS_USE_ALIAS) {
        qrValue = product?.code;
      } else {
        qrValue =
          product?.pcode || product?.attributes?.ProductId || product?.attributes?.Variant_Id;
      }
      // const qrValue =
      //   product?.attributes?.ProductId || product?.pcode || product?.attributes?.Variant_Id;

      if (!qrValue) {
        console.warn('QR value missing for product:', product);
        return; // skip this product
      }
      qrCode.addData(qrValue);
      qrCode.make();
      const qrCodeImage = qrCode.createDataURL(0, 0, { scale: 8, margin: 0 });

      pdf.addImage(qrCodeImage, 'JPEG', qrX, qrY, qrCodeSize, qrCodeSize);

      // Draw text below QR code
      const textY = qrY + qrCodeSize + spacing + 2; // small baseline tweak
      pdf.setFontSize(12);
      pdf.text(`${qrValue || product?.pcode}`, x + contentWidth / 2, textY, { align: 'center' });

      // Move x for next block horizontally
      x += contentWidth + blockSpacing;
    }

    pdf.save('QRPrint.pdf');
    setIsQRLoading3(false);
  };
  const handleDownloadQR6 = async (productData, data1) => {
    setIsQRLoading6(true);
    const pdf = new jsPDF({ unit: 'mm', format: 'a4' });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 1;

    const logoUrl = data1?.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
    const img = logoUrl ? `${globalIP}${logoUrl}` : null;

    if (productData.length === 0) {
      alert('No rows selected for export QR Code!');
      return;
    }

    let logoBase64 = null;
    if (img) {
      logoBase64 = await loadImageAsBase64(img);
    }

    const blockSpacing = 4; // mm spacing between blocks
    const spacing = 1.5; // mm vertical spacing between logo, QR, and text
    const textAreaHeight = 8; // mm height for text area
    const borderPadding = 1.5; // padding inside border

    let x = margin;
    let y = margin;

    for (let i = 0; i < productData.length; i++) {
      const product = productData[i];

      // Max logo size reduced to fit block
      let actualLogoWidth = 0;
      let actualLogoHeight = 0;
      if (logoBase64) {
        const logoDimensions = await loadImageSafe(img);
        if (logoDimensions) {
          let logoWidth = logoDimensions.width;
          let logoHeight = logoDimensions.height;

          const maxLogoWidth = 30; // max width in mm (~2 cm)
          const maxLogoHeight = 5; // max height in mm

          const scale = Math.min(maxLogoWidth / logoWidth, maxLogoHeight / logoHeight, 1);
          actualLogoWidth = logoWidth * scale;
          actualLogoHeight = logoHeight * scale;
        }
      }

      const qrCodeSize = 24; // 20 mm = 2 cm

      // Calculate total content width and height for border
      const originalContentWidth = Math.max(actualLogoWidth, qrCodeSize) + borderPadding * 2;
      const extraWidth = 2.5; // your requested width increase
      const contentWidth = originalContentWidth + extraWidth;
      const bottomTrim = 2; // Reduce border height from bottom
      const contentHeight =
        actualLogoHeight +
        spacing +
        qrCodeSize +
        spacing +
        textAreaHeight +
        borderPadding * 2 -
        bottomTrim;

      // Check for horizontal page break
      if (x + contentWidth + margin > pageWidth) {
        x = margin;
        y += contentHeight + blockSpacing;
      }

      // Check for vertical page break
      if (y + contentHeight + margin > pageHeight) {
        pdf.addPage();
        x = margin;
        y = margin;
      }

      // Draw border around content
      pdf.setDrawColor(0);
      pdf.setLineWidth(0.3);
      pdf.rect(x, y, contentWidth, contentHeight);

      // Draw logo centered inside border with padding
      if (logoBase64 && actualLogoHeight > 0) {
        const logoX = x + (contentWidth - actualLogoWidth) / 2;
        const logoY = y + borderPadding;
        pdf.addImage(logoBase64, 'PNG', logoX, logoY, actualLogoWidth, actualLogoHeight);
      }

      // Draw QR code below logo
      const qrX = x + (contentWidth - qrCodeSize) / 2;
      const qrY = y + borderPadding + actualLogoHeight + spacing;

      const qrCode = QRCode(0, 'L');
      let qrValue;

      if (IS_USE_ALIAS) {
        qrValue = product?.code;
      } else {
        qrValue =
          product?.pcode || product?.attributes?.ProductId || product?.attributes?.Variant_Id;
      }
      // const qrValue =
      //   product?.attributes?.ProductId || product?.pcode || product?.attributes?.Variant_Id;

      if (!qrValue) {
        console.warn('QR value missing for product:', product);
        return; // skip this product
      }
      qrCode.addData(qrValue);
      qrCode.make();
      const qrCodeImage = qrCode.createDataURL(0, 0, { scale: 8, margin: 0 });

      pdf.addImage(qrCodeImage, 'JPEG', qrX, qrY, qrCodeSize, qrCodeSize);

      // Draw text below QR code
      const textY = qrY + qrCodeSize + spacing + 2; // small baseline tweak
      pdf.setFontSize(10);
      pdf.text(`${qrValue || product?.pcode}`, x + contentWidth / 2, textY, { align: 'center' });

      const secondLineY = textY + 4; // 4mm below the first line (adjust as needed)
      const hasDimensions =
        product?.attributes?.Length &&
        product?.attributes?.Width &&
        product?.attributes?.Height &&
        product?.attributes?.SizeUnit;

      const computedSize = hasDimensions
        ? `${product.attributes.Length}x${product.attributes.Width}x${product.attributes.Height} ${product.attributes.SizeUnit}`
        : null;

      const sizeValue = computedSize || product?.size || '';

      pdf.setFontSize(7);
      pdf.text(`${sizeValue}`, x + contentWidth / 2, secondLineY, { align: 'center' });

      // Move x for next block horizontally
      x += contentWidth + blockSpacing;
    }

    pdf.save('QRPrint.pdf');
    setIsQRLoading6(false);
  };

  // Utility: Convert image URL to Base64
  const loadImageAsBase64 = url => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = err => reject(err);
      img.src = url;
    });
  };

  const handleDownloadQR4 = async (productData, data1) => {
    setIsQRLoading4(true);
    // Use 'letter' page size
    const pdf = new jsPDF({ unit: 'mm', format: [127, 127] });

    const logoUrl = data1?.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
    const img = logoUrl ? `${globalIP}${logoUrl}` : null;

    if (productData.length === 0) {
      alert('No rows selected for export QR Code!');
      return;
    }
    for (const [index, product] of productData.entries()) {
      if (index !== 0) {
        pdf.addPage(); // new page for every product
      }
      const pageWidth = pdf.internal.pageSize.getWidth();
      const margin = 6.5;
      // Draw QR container box (optional)

      // Add logo
      if (img) {
        const logoDimensions = await loadImageSafe(img);
        if (logoDimensions) {
          const maxLogoWidth = 100;
          const maxLogoHeight = 35;

          let logoWidth = logoDimensions.width;
          let logoHeight = logoDimensions.height;

          const scale = Math.min(maxLogoWidth / logoWidth, maxLogoHeight / logoHeight, 1);
          logoWidth *= scale;
          logoHeight *= scale;

          const logoX = (pageWidth - logoWidth) / 2;
          const logoY = margin;

          pdf.addImage(img, 'JPEG', logoX, logoY, logoWidth, logoHeight);
        }
      }

      // Generate and add QR code
      const qrCode = QRCode(0, 'L');
      let qrValue;

      if (IS_USE_ALIAS) {
        qrValue = product?.code;
      } else {
        qrValue =
          product?.pcode || product?.attributes?.ProductId || product?.attributes?.Variant_Id;
      }
      // const qrValue =
      //   product?.attributes?.ProductId || product?.pcode || product?.attributes?.Variant_Id;

      if (!qrValue) {
        console.warn('QR value missing for product:', product);
        return; // skip this product
      }
      qrCode.addData(qrValue);
      qrCode.make();
      const qrCodeImage = qrCode.createDataURL(0, 0, { scale: 8, margin: 0 });

      const qrCodeSize = 70;
      const qrX = (pageWidth - qrCodeSize) / 2;
      const qrY = 30;

      pdf.addImage(qrCodeImage, 'JPEG', qrX, qrY, qrCodeSize, qrCodeSize);

      // Add product code and size text
      const codeText = `Alias Code: ${qrValue || product?.pcode}`;
      const hasDimensions =
        product?.attributes?.Length &&
        product?.attributes?.Width &&
        product?.attributes?.Height &&
        product?.attributes?.SizeUnit;

      const computedSize = hasDimensions
        ? `${product.attributes.Length}x${product.attributes.Width}x${product.attributes.Height} ${product.attributes.SizeUnit}`
        : null;

      const sizeValue = computedSize || product?.size || '';

      const sizeText = sizeValue ? `Size: ${sizeValue}` : '';

      pdf.setFontSize(18);

      // Always render code text
      const codeWidth = pdf.getTextWidth(codeText);
      const codeX = (pageWidth - codeWidth) / 2;
      const codeY = qrY + qrCodeSize + 10;

      pdf.text(codeText, codeX, codeY);

      // Only render size text if it exists
      if (sizeValue) {
        const sizeWidth = pdf.getTextWidth(sizeText);
        const sizeX = (pageWidth - sizeWidth) / 2;
        const sizeY = codeY + 8;

        pdf.text(sizeText, sizeX, sizeY);
      }
    }
    pdf.save('QRPrint.pdf');
    setIsQRLoading4(false);
  };

  const handleDownloadQR5 = async (productData, data1) => {
    setIsQRLoading5(true);
    const pdf = new jsPDF({ unit: 'mm', orientation: 'landscape', format: [127, 228.6] });

    const logoUrl = data1?.length > 0 ? data1[0].attributes?.Logo?.data?.attributes?.url : '';
    const img = logoUrl ? `${globalIP}${logoUrl}` : null;

    if (productData.length === 0) {
      alert('No rows selected for export QR Code!');
      return;
    }
    for (const [index, product] of productData.entries()) {
      if (index !== 0) {
        pdf.addPage(); // new page for every product
      }
      const pageWidth = pdf.internal.pageSize.getWidth();
      const margin = 2;
      // Draw QR container box (optional)
      let startX = 0;
      // Add logo
      if (img) {
        const logoDimensions = await loadImageSafe(img);
        if (logoDimensions) {
          const maxLogoWidth = 75;
          const maxLogoHeight = 22;

          let logoWidth = logoDimensions.width;
          let logoHeight = logoDimensions.height;

          const scale = Math.min(maxLogoWidth / logoWidth, maxLogoHeight / logoHeight, 1);
          logoWidth *= scale;
          logoHeight *= scale;

          const logoX = 15;
          const logoY = margin;

          pdf.addImage(img, 'JPEG', logoX, logoY, 75, logoHeight - 0.5);
          startX = logoX;
        }
      }

      // Generate and add QR code
      const qrCode = QRCode(0, 'L');
      let qrValue;

      if (IS_USE_ALIAS) {
        qrValue = product?.code;
      } else {
        qrValue =
          product?.pcode || product?.attributes?.ProductId || product?.attributes?.Variant_Id;
      }
      // const qrValue =
      //   product?.attributes?.ProductId || product?.pcode || product?.attributes?.Variant_Id;

      if (!qrValue) {
        console.warn('QR value missing for product:', product);
        return; // skip this product
      }
      qrCode.addData(qrValue);
      qrCode.make();
      const qrCodeImage = qrCode.createDataURL(0, 0, { scale: 8, margin: 0 });

      const qrCodeSize = 75;
      const qrX = (pageWidth - qrCodeSize) / 2;
      const qrY = 22;

      pdf.addImage(qrCodeImage, 'JPEG', startX, qrY, qrCodeSize, qrCodeSize);

      // Add product code and size text
      const nameX = startX;
      const nameY = 30 + qrCodeSize;
      const nameMaxWidth = 100;
      pdf.setFont('sans-serif', 'bold');
      pdf.text(`Name : `, nameX, nameY);
      const nameLines = pdf.splitTextToSize(
        product?.attributes?.ProductName || product?.name,
        nameMaxWidth
      );
      pdf.setFont('sans-serif', 'normal');
      pdf.text(nameLines, nameX + pdf.getTextWidth('Name : '), nameY);

      const lineHeight = 3.8;
      const nameHeight = nameLines.length * lineHeight;
      let afterNameY = nameY + nameHeight;

      // Material
      // pdf.setFont('sans-serif', 'bold');
      // pdf.text(`Material : `, startX, afterNameY + lineHeight);
      // pdf.setFont('sans-serif', 'normal');
      // pdf.text(
      //   `${product.material}`,
      //   startX + pdf.getTextWidth('Material : '),
      //   afterNameY + lineHeight
      // );

      // Finish
      pdf.setFont('sans-serif', 'bold');
      pdf.text(`Finish : `, startX, afterNameY + lineHeight);
      pdf.setFont('sans-serif', 'normal');
      pdf.text(
        `${product?.attributes?.FinishName || product?.finish}`,
        startX + pdf.getTextWidth('Finish : '),
        afterNameY + lineHeight
      );

      // Net Weight
      pdf.setFont('sans-serif', 'bold');
      pdf.text(`Net Wt : `, 70 * 2.6, afterNameY + lineHeight * 3);
      pdf.setFont('sans-serif', 'normal');
      pdf.text(
        `${product?.attributes?.NetWeight || product?.ntwt}`,
        70 * 2.6 + pdf.getTextWidth('Net Wt : '),
        afterNameY + lineHeight * 3
      );

      const centeredX = startX * 4 + qrCodeSize;
      const centeredY = qrY;
      // Code
      pdf.setFontSize(25);
      pdf.setFont('sans-serif', 'bold');
      pdf.text('Code: ', centeredX, 10);
      pdf.text(
        `${product?.attributes?.ProductId || product?.pcode}`,
        centeredX + pdf.getTextWidth('Code: '),
        10
      );
      pdf.setFontSize(15);

      const img1 = product.image;
      const imgp = img1 ? `${globalIP}${img1}` : null;
      const productImageDimensions = imgp ? await loadImageSafe(imgp) : null;

      if (productImageDimensions) {
        const maxImageWidth = qrCodeSize;
        const maxImageHeight = qrCodeSize;
        let productImageWidth = productImageDimensions.width;
        let productImageHeight = productImageDimensions.height;

        const widthRatio = maxImageWidth / productImageWidth;
        const heightRatio = maxImageHeight / productImageHeight;
        const scaleRatio = Math.min(widthRatio, heightRatio);

        if (scaleRatio < 1) {
          productImageWidth *= scaleRatio;
          productImageHeight *= scaleRatio;
        }

        pdf.addImage(imgp, 'JPEG', centeredX, centeredY, productImageWidth, productImageHeight);
      }
    }
    pdf.save('QRPrint.pdf');
    setIsQRLoading5(false);
  };
  const [maindata, setMainData] = useState([]);
  const [maindataexcel, setMainDataExcel] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [allFilteredProducts, setAllFilteredProducts] = useState([]);

  useEffect(() => {
    const selectedProductsData = selectedRowIds
      .map(id => allFilteredProducts.find(p => p.id === id))
      .filter(Boolean);

    setSelectedProducts(selectedProductsData);
  }, [selectedRowIds, allFilteredProducts]);

  useEffect(() => {
    if (selectedRowIds.length) {
      fetchDataforQR(selectedRowIds);
    }
  }, [selectedRowIds]);

  // Remove this useEffect entirely and call fetchDataforQR only when needed

  // Or if you need to keep some functionality, modify it to be more efficient:
  // useEffect(() => {
  //   // Only fetch when we have selections AND we're about to use QR data
  //   // Add a condition to prevent unnecessary calls
  //   if (selectedRowIds.length > 0 && (action === 'View' || isCartOpen)) {
  //     fetchDataforQR(selectedRowIds);
  //   }
  // }, [selectedRowIds, action, isCartOpen]); // Add dependencies to control when it runs

  // console.log(selectedRowIds)
  const [isLoadingFairData, setIsLoadingFairData] = useState(false);
  const fetchDataforQR = async selectedFairIds => {
    setIsLoadingFairData(true);
    setIsLoading1(true);
    try {
      if (!selectedFairIds.length) return;

      const BATCH_SIZE = 50; // Reduced batch size to avoid URL length limits
      const allProductData = [];

      // Process in batches
      for (let i = 0; i < selectedFairIds.length; i += BATCH_SIZE) {
        const batch = selectedFairIds.slice(i, i + BATCH_SIZE);

        // 1️⃣ Fetch fair-product-masters for this batch using $in
        const fairFilters = batch.map(id => `filters[id][$in][]=${id}`).join('&');
        const fairApiUrl = `${globalIP}/api/fair-product-masters?${fairFilters}&pagination[pageSize]=${batch.length}`;

        const fairResponse = await fetch(fairApiUrl);
        const fairJson = await fairResponse.json();

        const fairData = fairJson.data || [];

        // 2️⃣ Extract prdcd values
        const numericIds = [];
        const productCodes = [];

        fairData.forEach(f => {
          const prdcd = f.attributes?.prdcd;
          if (!prdcd) return;

          const clean = String(prdcd).trim();
          if (!isNaN(clean)) numericIds.push(clean);
          else productCodes.push(clean);
        });

        if (!numericIds.length && !productCodes.length) continue;

        // 3️⃣ Build Strapi filters using $in (NOT $eq)
        const filters = [];

        // ✅ Use $in for multiple IDs - this is the key fix!
        if (numericIds.length > 0) {
          const numericFilters = numericIds.map(id => `filters[id][$in][]=${id}`).join('&');
          filters.push(numericFilters);
        }

        if (productCodes.length > 0) {
          const codeFilters = productCodes
            .map(code => `filters[ProductCode][$in][]=${encodeURIComponent(code)}`)
            .join('&');
          filters.push(codeFilters);
        }

        // 4️⃣ Fetch products for this batch
        const apiUrl = `${globalIP}/api/products?populate=*&${filters.join(
          '&'
        )}&pagination[pageSize]=1000`;
        const response = await fetch(apiUrl);
        const json = await response.json();

        allProductData.push(...(json.data || []));

        console.log(
          `Batch ${Math.floor(i / BATCH_SIZE) + 1}: Fetched ${json.data?.length || 0} products`
        );
      }

      // 5️⃣ Map to required format
      const productData = allProductData.map(item => ({
        code: item?.attributes?.ProductId ?? '',
        name: item?.attributes?.ProductName ?? '',
        size: `${item?.attributes?.Length ?? ''}x${item?.attributes?.Width ?? ''}x${
          item?.attributes?.Height ?? ''
        } ${item?.attributes?.SizeUnit ?? ''}`,
        pcode: item?.attributes?.ProductCode ?? '',
        image: item?.attributes?.CoverImage?.data?.attributes?.url ?? '',
        grwt: item?.attributes?.GrossWeight ?? '',
        ntwt: item?.attributes?.NetWeight ?? '',
        material: item?.attributes?.ProductionDetail?.MaterialCode ?? '',
        finish: item?.attributes?.FinishName ?? '',
        attributes: item.attributes // Keep full attributes for template compatibility
      }));

      setMainData(productData);
      setMainDataExcel(allProductData);

      const totalBatches = Math.ceil(selectedFairIds.length / BATCH_SIZE);
      console.log(`✅ Fetched ${productData.length} products in ${totalBatches * 2} API calls`);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoadingFairData(false);
      setIsLoading1(false);
    }
  };

  //// QR CODE ////

  //// Fair Add ////
  const [fairStatuses, setFairStatuses] = useState({});
  const [fairdata, setFairData] = useState([]);
  const [fairmeta, setFairmeta] = useState(0);
  useEffect(() => {
    fetchDataEnc();
  }, []);
  const fetchDataEnc = async () => {
    const response = await fetch(`${globalIP}/api/fair-masters?populate=*`);
    const json = await response.json();
    const statuses = json.data.reduce((statusObj, fair) => {
      statusObj[fair.id] = fair.attributes.fairstatus;
      return statusObj;
    }, {});
    setFairData(json.data);
    setFairmeta(json.meta.pagination.total);
    setFairStatuses(statuses);
  };
  ///////

  //// remove products /////
  const [getproduct, setGetProduct] = useState([]);

  useEffect(() => {
    if (selectedRowIds.length > 0) {
      fetchDataFairget();
    }
  }, [selectedRowIds]);
  const [loading, setLoading] = useState(false);
  const fetchDataFairget = async () => {
    setLoading(true);
    try {
      const getids = [];
      let selectedidsfilter = '';
      const FilterString = selectedRowIds.map(rowId => `&filters[id][$eq]=${rowId}`).join('&');
      selectedidsfilter = `&${FilterString}`;
      const response1 = await fetch(`${globalIP}/api/products?populate=*${selectedidsfilter}`);
      const json1 = await response1.json();
      const response2 = await fetch(
        `${globalIP}/api/products?populate=*?${selectedidsfilter}&pagination[pageSize]=${json1?.meta?.pagination?.total}`
      );
      const json2 = await response2.json();
      let productcodefilter = '';
      if (json2.data.length > 0) {
        const FilterString = json2.data.map(item => `filters[prdcd][$eq]=${item.id}`).join('&');
        productcodefilter = `&${FilterString}`;
      }
      const response3 = await fetch(
        `${globalIP}/api/fair-product-masters?populate=*${productcodefilter}`
      );
      const json3 = await response3.json();
      const response4 = await fetch(
        `${globalIP}/api/fair-product-masters?populate=*${productcodefilter}&pagination[pageSize]=${json3?.meta?.pagination?.total}`
      );
      const json4 = await response4.json();
      const fairProduct = json4.data;
      if (fairProduct.length > 0) {
        fairProduct.map(item => getids.push(item.id));
      }
      // Set the accumulated IDs in the state
      setGetProduct(getids);
    } catch (error) {
      console.error('Error fetching fair-product data:', error);
    }
    setLoading(false);
  };
  const [open3, setOpen3] = useState(false);
  const handleOpen3 = () => setOpen3(true);
  const handleClose3 = () => {
    setCurrentPage(1); // ✅ Reset page
    setData123([]);
    setOpen3(false);
    window.location.reload();
  };

  const deleteFairProducts = async () => {
    if (selectedRowIds.length === 0) return;

    setIsLoading1(true);
    try {
      const deletePromises = selectedRowIds.map(id =>
        fetch(`${globalIP}/api/fair-product-masters/${id}`, { method: 'DELETE' })
      );

      await Promise.all(deletePromises);

      // Refresh data after deletion
      setSelectedRowIds([]);

      handleOpen3();
    } catch (err) {
      console.error('Delete error:', err);
      handleOpen3();
    } finally {
      setIsLoading1(false);
    }
  };
  const fetchData1 = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    try {
      const response = await fetch(
        `${globalIP}/api/mstcategories?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/mstcategories?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data
          .map(item => {
            const label = item.attributes?.CategoryName?.trim();
            const value = item.attributes?.CategoryCode?.trim();

            // ❌ Skip empty
            if (!label || !value) return null;

            return { label, value };
          })
          .filter(Boolean); // remove null

        allData.push(...processedData);
      }
      const sortedData = allData.sort((a, b) => a.label.localeCompare(b.label));
      setCategorydata(sortedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchData2 = async () => {
    if (isLoadingpro) {
      return;
    }
    setIsLoadingpro(true);
    try {
      const productIdsQueryParam = selectedCategoryCode
        .map(id => `filters[Categorycode][$in][]=${id}`)
        .join('&');
      // Construct the API URL by appending the query parameters
      const apiUrl = `${globalIP}/api/mstproducttypes?${productIdsQueryParam}&populate=*&pagination[page]=1`;

      const response = await fetch(apiUrl);
      const json = await response.json();

      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/mstproducttypes?${productIdsQueryParam}&populate=*&pagination[page]=${page}`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.ProductTypeName,
          value: item.attributes.ProductTypeCode
        }));
        allData.push(...processedData);
      }
      // setProductypedata(allData.sort((a, b) => a.label.localeCompare(b.label)));
      const finalData = allData
        .filter(item => item.label && item.value) // remove empty
        .filter((item, index, self) => index === self.findIndex(t => t.value === item.value)) // remove duplicate by value
        .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));

      setProductypedata(finalData);
      setIsLoadingpro(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchData3 = async () => {
    if (isLoadingalias) {
      return;
    }
    setIsLoadinalias(true);
    try {
      const response = await fetch(`${globalIP}/api/fetchs-aliascd`);
      const json = await response.json();
      const processedData = json
        .map(item => {
          const productId = item?.ProductId?.trim();

          if (!productId) return null; // ❌ skip empty

          return {
            label: productId,
            value: productId
          };
        })
        .filter(Boolean) // remove null
        .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));

      setAliasdata(processedData);

      setIsLoadinalias(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchData4 = async () => {
    if (isLoadingpron) {
      return;
    }
    setIsLoadingpron(true);
    try {
      const response = await fetch(`${globalIP}/api/products-name`);
      const json = await response.json();
      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords

      json.forEach(item => {
        if (item.ProductName && !uniqueKeywords.has(item.ProductName)) {
          uniqueKeywords.add(item.ProductName);
        }
      });

      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setProdNamedata(processedData.sort((a, b) => a.label.localeCompare(b.label)));
      setIsLoadingpron(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchData5 = async () => {
    if (isLoadingsku) {
      return;
    }
    setIsLoadinsku(true);
    try {
      const response = await fetch(`${globalIP}/api/buyers-sku`);
      const json = await response.json();
      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
      json.forEach(item => {
        if (item.BuyerSku && !uniqueKeywords.has(item.BuyerSku)) {
          uniqueKeywords.add(item.BuyerSku);
        }
      });
      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setSkudata(processedData.sort((a, b) => a.label.localeCompare(b.label)));
      setIsLoadinsku(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchData6 = async () => {
    if (isLoadingbu) {
      return;
    }
    setIsLoadingbu(true);
    try {
      const response = await fetch(`${globalIP}/api/buyer-details?&pagination[page]=1`);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(`${globalIP}/api/buyer-details?&pagination[page]=${page}`);
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.buyernm,
          value: item.attributes.buyernm
        }));
        allData.push(...processedData);
      }
      setBuyerNamedata(allData.sort((a, b) => a.label.localeCompare(b.label)));
      setIsLoadingbu(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchData7 = async () => {
    if (isLoadingfin) {
      return;
    }
    setIsLoadingfin(true);
    try {
      const response = await fetch(
        `${globalIP}/api/mstfinishes?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/mstfinishes?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.FinishName,
          value: item.attributes.FinishCode
        }));
        allData.push(...processedData);
      }
      setFinishdata(allData.sort((a, b) => a.label.localeCompare(b.label)));
      setIsLoadingfin(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const fetchData8 = async () => {
    if (isLoadingcolor) return;
    setIsLoadingcolor(true);
    try {
      const response = await fetch(
        `${globalIP}/api/mstcolors?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];

      for (let page = 1; page <= (json.meta?.pagination?.pageCount || 1); page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/mstcolors?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = (pageJson.data || []).map(item => ({
          label: item.attributes?.ColorName || '',
          value: item.attributes?.ColorCode || ''
        }));
        allData.push(...processedData);
      }

      setColordata(
        allData.sort((a, b) => {
          const labelA = a.label || '';
          const labelB = b.label || '';
          return labelA.localeCompare(labelB);
        })
      );
    } catch (error) {
      console.error('Error fetching category data:', error);
    } finally {
      setIsLoadingcolor(false);
    }
  };

  const fetchData9 = async () => {
    if (isLoadingse) {
      return;
    }
    setIsLoadingse(true);
    try {
      const response = await fetch(`${globalIP}/api/searchs-keyword`);
      const json = await response.json();
      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords

      json.forEach(item => {
        if (item.SearchKeyword && !uniqueKeywords.has(item.SearchKeyword)) {
          uniqueKeywords.add(item.SearchKeyword);
        }
      });

      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setSearchdata(processedData.sort((a, b) => a.label.localeCompare(b.label)));
      setIsLoadingse(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchData10 = async () => {
    if (isLoadingprod) {
      return;
    }
    setIsLoadingprod(true);
    try {
      const response = await fetch(`${globalIP}/api/products-designer`);
      const json = await response.json();
      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
      json.forEach(item => {
        if (item.ProductDesigner && !uniqueKeywords.has(item.ProductDesigner)) {
          uniqueKeywords.add(item.ProductDesigner);
        }
      });
      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setProdDdata(processedData.sort((a, b) => a.label.localeCompare(b.label)));
      setIsLoadingprod(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchData11 = async () => {
    if (isLoadingmade) {
      return;
    }
    setIsLoadingmade(true);
    try {
      const response = await fetch(`${globalIP}/api/mades-by`);
      const json = await response.json();

      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
      json.forEach(item => {
        if (item.MadeBy && !uniqueKeywords.has(item.MadeBy)) {
          uniqueKeywords.add(item.MadeBy);
        }
      });
      const processedData = Array.from(uniqueKeywords).map(keyword => ({
        label: keyword,
        value: keyword
      }));
      setMadedata(processedData.sort((a, b) => a.label.localeCompare(b.label)));
      setIsLoadingmade(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchData12 = async () => {
    try {
      const response = await fetch(
        `${globalIP}/api/msthscodes?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/msthscodes?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.hscode,
          value: item.attributes.hscode
        }));
        allData.push(...processedData);
      }
      setHsndata(allData.sort((a, b) => a.label.localeCompare(b.label)));
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const handleFilterDrawerOpen = () => {
    setOpenD(true);

    // Fetch only if not already loaded
    if (categorydata.length === 0) fetchData1();
    if (productypedata.length === 0) fetchData2();
    if (aliasdata.length === 0) fetchData3();
    if (proNamedata.length === 0) fetchData4();
    if (skudata.length === 0) fetchData5();
    if (buyernamedata.length === 0) fetchData6();
    if (finishdata.length === 0) fetchData7();
    if (colordata.length === 0) fetchData8();
    if (searchdata.length === 0) fetchData9();
    if (proDdata.length === 0) fetchData10();
    if (madedata.length === 0) fetchData11();
    if (hsndata.length === 0) fetchData12();
  };
  // const handleCategoryChange = value => {
  //   setSearchQuery('');
  //   setCurrentPage(1);
  //   setSelectedCategoryCode(value);
  // };
  const handleCategoryChange = value => {
    setSearchQuery('');
    setCurrentPage(1);
    setData123([]); // Clear existing data
    setSelectedCategoryCode(value);
  };
  // const handleProductTypeChange = value => {
  //   setSearchQuery('');
  //   setCurrentPage(1); // Reset page when color changes
  //   setSelectedProductType(value);
  // };

  const handleProductTypeChange = value => {
    setSearchQuery('');
    setCurrentPage(1);
    setData123([]); // Clear existing data
    setSelectedProductType(value);
  };

  const handleAliasChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedAlias(value);
  };
  const handleColorChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedColor(value);
  };
  const handleFinishChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedFinish(value);
  };
  const handleHSNChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedhsn(value);
  };
  const handleBuyerChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedBuyer(value);
  };
  const handleSearchChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedSearch(value);
  };

  const handleProNameChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedPron(value);
  };
  const handleProDChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedProd(value);
  };
  const handleMadeChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedMade(value);
  };
  const handleSkuChange = value => {
    setSearchQuery('');
    setCurrentPage(1); // Reset page when color changes
    setSelectedSku(value);
  };
  ///// api filter search /////

  ////// view products //////

  const getFilteredData = () => {
    const trimmedQuery = searchQuery.trim();
    if (!trimmedQuery) return data123;

    const searchLower = trimmedQuery.toLowerCase();

    return data123.filter(item => {
      const attrs = item.attributes;

      // Comprehensive search across all relevant fields
      const searchableFields = [
        'ProductId', // Alias Code
        'ProductName', // Product Name
        'Description', // Description
        'SearchKeyword', // Search Keyword
        'CategoryName', // Category
        'ProductTypeName', // Product Type
        'ColorName', // Color
        'FinishName', // Finish
        'ProductDesigner', // Product Designer
        'MadeBy', // Made By
        'BuyerSku', // Buyer SKU
        'BuyerName', // Buyer Name
        'HSNCode', // HSN Code
        'SizeRange', // Size Range
        'ProductCode' // Product Code
      ];

      return searchableFields.some(field => {
        const value = attrs[field];
        return value && typeof value === 'string' && value.toLowerCase().includes(searchLower);
      });
    });
  };

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${globalIP}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const columns = [
    {
      key: 'Image',
      label: 'Image',
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Image</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell>
          {rowData => {
            // Define a function to show the enlarged image on hover
            const renderTooltip = imageSrc => (
              <Tooltip style={{ backgroundColor: 'white' }}>
                <img src={imageSrc} alt="Product Image" style={{ width: 400, height: 'auto' }} />
              </Tooltip>
            );

            return (
              <Whisper
                followCursor
                trigger="hover"
                placement="right"
                speaker={renderTooltip(
                  `${globalIP}${rowData.attributes.CoverImage.data.attributes.url}`
                )}
              >
                <img
                  src={`${globalIP}${rowData.attributes.CoverImage.data.attributes.url}`}
                  alt="Product Image"
                  style={{ width: 50, height: 50, marginTop: '-12px' }}
                />
              </Whisper>
            );
          }}
        </Table.Cell>
      )
    },
    {
      key: 'ProductId',
      label: `${label[0]?.attributes.AliasCode}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.AliasCode}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.ProductId}</Cell>
    },
    {
      key: 'Description',
      label: `${label[0]?.attributes.Description}`,
      width: 250,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.Description}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.Description}</Cell>
    },
    {
      key: 'ProductName',
      label: `${label[0]?.attributes.ProductName}`,
      width: 300,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.ProductName}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.ProductName}</Cell>
    },
    {
      key: 'Dimension',
      label: `${label[0]?.attributes.SizeRange}`,
      width: 200,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.SizeRange}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.SizeRange}</Cell>
    },
    {
      key: 'FinishName',
      label: `${label[0]?.attributes.finish}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.finish}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.FinishName}</Cell>
    },
    {
      key: 'ColorName',
      label: `${label[0]?.attributes.color}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.color}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.ColorName}</Cell>
    }
  ];
  const [columnKeys, setColumnKeys] = useState(columns.map(column => column.key));
  const [viewData, setViewData] = useState([]);
  // const [viewMeta, setViewMeta] = useState([]);
  const [viewMeta, setViewMeta] = useState(null);
  const [viewload, setViewLoad] = useState(false);
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentPage(1);
      setDebouncedSearchQuery(searchQuery);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
  const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;
  const CustomCell = CompactCell;
  const CustomHeaderCell = CompactHeaderCell;
  ////// view products ///////

  ////// qr prints ///////
  const [openq, setOpenq] = useState(false);
  ///// qr prints //////
  const [shfilter, setShfilter] = useState(false);
  const csvData = maindataexcel.map(item => {
    const { id, attributes } = item;
    const {
      MaterialCollection,
      ProductionDetail,
      MultipleImage,
      CoverImage,
      Packaging,
      FortyHQ,
      FortyFT,
      TwentyFT,
      Total_CBM,
      publishedAt,
      updatedAt,
      createdAt,
      BuyerSku,
      BuyerName,
      ColorName,
      cbm,
      ProductTypeCode,
      MadeBy,
      ProductDesigner,
      MOQ,
      SearchKeyword,
      ProductCost,
      HSNCode,
      ColorCode,
      FinishCode,
      ProductCode,
      CategoryCode,
      Total_CFT,
      ...restAttributes
    } = attributes;
    let imageUrl;
    if (attributes.CoverImage?.data?.attributes?.url) {
      imageUrl = `${globalIP}${attributes.CoverImage?.data?.attributes?.url || ''}`;
    }
    return {
      id,
      Image: imageUrl,
      ...restAttributes
    };
  });
  const [iscsvLoading, setIsCsvLoading] = useState(false);
  const downloadExcelData = async data => {
    setIsCsvLoading(true);
    // console.log('data');
    // console.log(data);
    const attributesToRemove = [
      'GrossWeight',
      'SellingPriceUnit',
      'Variant_Id',
      'Buyer_Remark',
      'Product_Remark',
      'SellingPriceCurrency',
      'SellingPrice',
      'ProductTypeName'
    ];
    const headerMapping = {
      id: 'Item No.',
      ProductId: 'Alias Code', // Change "ProductId" to "Alias Code" in the header
      NetWeight: 'Net. Wt.',
      CategoryName: 'Category',
      FinishName: 'Finish',
      SizeUnit: 'Item Size',
      ProductName: 'Product Name',
      ProductCost: 'Price'
      // Add more header mappings as needed
    };
    const companyName = data1[0]?.attributes?.cmpnm || 'Your Company Name';
    const logoUrl = data1[0]?.attributes?.Logo?.data?.attributes?.url || '';
    const imag = `${globalIP}${logoUrl}`;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1', {
      properties: {
        tabColor: {
          argb: 'FFC00000' // Adjust tab color as needed
        }
      }
    });
    const companyNameRow = worksheet.addRow([]);
    // Center the text in the cell
    companyNameRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
    // Increase font size and make it bold
    companyNameRow.getCell(1).font = { size: 16, bold: true };
    const conpmayRow = worksheet.getRow(1); // Assuming the header is in the first row
    conpmayRow.height = 30;
    worksheet.mergeCells('A1:M2');
    worksheet.getCell('E1').value = companyName;
    // Add header row

    if (imag) {
      const logoResponse = await fetch(imag);
      const logoImageBuffer = await logoResponse.arrayBuffer();
      const logoImageId = workbook.addImage({
        buffer: logoImageBuffer,
        extension: 'png' // Adjust the image format as needed
      });

      // Insert the logo in a cell to the left of the company name cell
      worksheet.addImage(logoImageId, { tl: { col: 1, row: 0.5 }, ext: { width: 80, height: 40 } });
    }

    const desiredColumnOrder = [
      'id',
      'Image',
      'ProductId',
      'Description',
      'ProductName',
      'SizeUnit',
      'Length',
      'Width',
      'Height',
      'NetWeight',
      'CategoryName',
      'FinishName',
      'ProductCost'

      // ... (other columns)
    ];

    // const header = Object.keys(data[0]).filter(key => !attributesToRemove.includes(key));
    const headerchange = desiredColumnOrder.map(key => headerMapping[key] || key);
    worksheet.addRow([]); // Add an empty row before headers

    worksheet.addRow(['Item No.', 'Image', 'Alias Code', 'Description', 'ProductName', 'Unit']); // Add the 'Item No.' to cells A3 and A4
    worksheet.mergeCells('A3:A4'); // Merge cells for 'Item No.'
    worksheet.mergeCells('B3:B4'); // Merge cells for 'Item No.'
    worksheet.mergeCells('C3:C4');
    worksheet.mergeCells('J3:J4');
    worksheet.mergeCells('K3:K4');
    worksheet.mergeCells('L3:L4');
    worksheet.mergeCells('M3:M4');
    worksheet.mergeCells('D3:D4');
    worksheet.mergeCells('E3:E4');
    worksheet.mergeCells('F3:F4');
    worksheet.getCell('G4').value = 'Master Carton Size';
    worksheet.mergeCells('G4:I4');
    worksheet.getCell('G4').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'cccaca' } // Set the desired color (here it's a shade of red)
    };
    const headerRow = worksheet.getRow(3); // Assuming the header is in the sixth row
    headerRow.values = headerchange; // Populate the headers starting from the sixth row
    headerRow.height = 30; // Adjust the height as needed

    headerRow.eachCell((cell, index) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'cccaca' }
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = {
        top: { style: 'medium', color: { argb: '00000000' } }, // Change the color as needed
        left: { style: 'medium', color: { argb: '00000000' } },
        bottom: { style: 'medium', color: { argb: '00000000' } },
        right: { style: 'medium', color: { argb: '00000000' } }
      };
    });
    worksheet.getColumn('B').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('D').width = 30; // Adjust the width as needed for column B
    worksheet.getColumn('E').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('F').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('C').width = 10; // Adjust the width as needed for column B
    worksheet.getColumn('K').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('L').width = 20; // Adjust the width as needed for column B
    // Fetch and embed images
    for (const item of data) {
      // ================================
      // 1️⃣ Prepare row values (UNCHANGED)
      // ================================
      const { Length, Width, Height, SizeUnit, Carton_Length, Carton_Width, Carton_Thick } = item;
      const unitString = `${Length}x${Width}x${Height} ${SizeUnit}`;

      const values = desiredColumnOrder.map(key => {
        if (key === 'SizeUnit') {
          return unitString || '';
        } else if (key === 'Carton_Length') {
          return item.Carton_Length ?? '';
        } else if (key === 'Carton_Thick') {
          return item.Carton_Width ?? '';
        } else if (key === 'Carton_Width') {
          return item.Carton_Thick ?? '';
        } else if (key === 'ProductCost') {
          return item.SellingPrice ? `${item.SellingPrice} ${item.SellingPriceCurrency ?? ''}` : '';
        } else if (key !== 'Image') {
          return item?.[key] ?? '';
        }

        return '';
      });

      // ================================
      // 2️⃣ Add row FIRST (IMPORTANT FIX)
      // ================================
      worksheet.addRow(values);

      const rowNumber = worksheet.rowCount;
      const row = worksheet.getRow(rowNumber);

      const imageUrl = item.Image;

      // ================================
      // 3️⃣ Add Image AFTER row creation
      // ================================
      if (imageUrl) {
        // Load image to get dimensions
        const img = new Image();
        img.src = imageUrl;
        await new Promise(resolve => (img.onload = resolve));

        const imageWidth = img.width;
        const imageHeight = img.height;

        const maxWidth = 100;
        const maxHeight = 100;

        // Maintain aspect ratio
        let finalWidth = maxWidth;
        let finalHeight = (imageHeight / imageWidth) * maxWidth;

        if (finalHeight > maxHeight) {
          finalHeight = maxHeight;
          finalWidth = (imageWidth / imageHeight) * maxHeight;
        }

        // Fetch image buffer
        const response = await fetch(imageUrl);
        const imageBuffer = await response.arrayBuffer();

        const imageId = workbook.addImage({
          buffer: imageBuffer,
          extension: 'png'
        });

        // ✅ Match row height to image with extra padding
        const excelRowHeight = finalHeight * 0.75;
        const padding = 15; // extra padding
        row.height = excelRowHeight + padding;

        // ✅ Center image horizontally and vertically in the cell
        const columnIndex = 1; // B column (zero-based = 1)
        const columnWidth = worksheet.getColumn(columnIndex + 1).width || 20;
        const approxColPixels = columnWidth * 7; // Approx conversion
        const approxRowPixels = row.height / 0.75; // Convert row height to pixels

        const offsetX = (approxColPixels - finalWidth) / 2;
        const offsetY = (approxRowPixels - finalHeight) / 2;

        worksheet.addImage(imageId, {
          tl: {
            col: columnIndex + offsetX / approxColPixels,
            row: rowNumber - 1 + offsetY / approxRowPixels
          },
          ext: {
            width: finalWidth,
            height: finalHeight
          },
          editAs: 'oneCell'
        });
      }

      // ================================
      // 4️⃣ Your existing formatting (UNCHANGED)
      // ================================
      row.eachCell((cell, colNumber) => {
        row.getCell(2).border = {
          top: { style: 'medium', color: { argb: '00000000' } },
          left: { style: 'medium', color: { argb: '00000000' } },
          bottom: { style: 'medium', color: { argb: '00000000' } },
          right: { style: 'medium', color: { argb: '00000000' } }
        };
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      });

      worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
        row.eachCell((cell, colNumber) => {
          cell.border = {
            top: { style: 'medium', color: { argb: '00000000' } },
            left: { style: 'medium', color: { argb: '00000000' } },
            bottom: { style: 'medium', color: { argb: '00000000' } },
            right: { style: 'medium', color: { argb: '00000000' } }
          };
          cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        });
      });
    }

    // Generate Excel buffer
    const excelBuffer = await workbook.xlsx.writeBuffer();
    // In a browser environment, you can use Blob and FileSaver to save the file
    const excelData = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    // Save the Excel file
    saveAs(excelData, `Product Details.xlsx`);
    setIsCsvLoading(false);
  };
  const [id, setId] = useState();
  const [openp, setOpenp] = useState(false);
  const [modeldata, setmodeldata] = useState([]);
  const [cost, setCost] = useState({
    totalinr: 0,
    targetcostUSD: 0
  });
  const [selectedImagePath, setSelectedImagePath] = useState('');
  const [calcwidth, setcalcwidth] = useState(1200);
  useEffect(() => {
    if (selectedImagePath?.url) {
      // Create a new Image object
      const img = new Image();
      img.src = globalIP + selectedImagePath?.url;

      // Once the image is loaded, calculate the width
      img.onload = () => {
        const newCalcWidth = (1200 * img.width) / img.height;
        setcalcwidth(newCalcWidth);
        // console.log('calcwidth', newCalcWidth);
      };
    }
    // console.log('selectedImagePath', selectedImagePath);
  }, [selectedImagePath?.url]);
  const [selectedUnit, setSelectedUnit] = useState('inch');
  const { attributesName } = useLabel();
  const [data11, setData11] = useState([]);
  const [imageList, setImageList] = useState([]);
  const defaultImageIndex = 0;
  const [selectedImageIndex, setSelectedImageIndex] = useState(defaultImageIndex);
  useEffect(() => {
    if (id) {
      fetchData1234();
    }
  }, [id]);
  const fetchData1234 = async () => {
    const response = await fetch(`${globalIP}/api/products?populate=*&filters[id][$eq]=${id}`);
    const json = await response.json();
    const filteredData = json.data.filter(item => item.id === id);
    setmodeldata(filteredData);
    if (filteredData[0].attributes.SetStatus === 'Set') {
      setData11(filteredData[0].attributes.SetSizes);
    } else {
      const data = [
        {
          Length: filteredData[0].attributes.Length,
          Width: filteredData[0].attributes.Width,
          Height: filteredData[0].attributes.Height,
          SizeUnit: filteredData[0].attributes.SizeUnit
        }
      ];
      setData11(data);
    }
    const extractedImageList = json.data
      .filter(item => item.attributes.MultipleImage && item.attributes.MultipleImage.data)
      .map(item => item.attributes.MultipleImage.data.map(image => image.attributes.url))
      .flat(); // Flatten the array of arrays
    const coverImage = json.data.map(item => item.attributes.CoverImage.data.attributes.url);
    extractedImageList.unshift(coverImage);
    const prefixed_list = extractedImageList.map(file => globalIP + file);
    setImageList(prefixed_list);
  };
  const unitOptions = [
    { label: 'Inch', value: 'inch' },
    { label: 'CM', value: 'cm' }
  ];
  const handleSizeChange = value => {
    // setSizeUnit(newSizeUnit);
    setSelectedUnit(value);
    const convertedData = convertDimensions(data11, value);
    setData11(convertedData);
  };
  const convertDimensions = (data, selectedUnit) => {
    const conversionFactor = selectedUnit === 'inch' ? 0.393701 : 2.54;

    return data.map(item => {
      // Skip conversion if the SizeUnit matches the selectedUnit
      if (item.SizeUnit === selectedUnit) {
        // console.log('Unchanged data:', item);
        return item;
      }

      // Convert dimensions if SizeUnit does not match the selectedUnit
      let convertedItem = {
        ...item,
        Length: (item.Length || 0) * conversionFactor,
        Width: (item.Width || 0) * conversionFactor,
        Height: (item.Height || 0) * conversionFactor,
        SizeUnit: selectedUnit
      };

      // console.log('Converted data:', convertedItem);
      return convertedItem;
    });
  };

  const handleNextImage = item => {
    const totalImages = item?.attributes?.MultipleImage?.data?.length + 1; // Add 1 for the CoverImage
    setSelectedImageIndex(prevIndex => (prevIndex + 1) % totalImages);
  };

  const handlePrevImage = item => {
    const totalImages = item?.attributes?.MultipleImage?.data?.length + 1; // Add 1 for the CoverImage
    setSelectedImageIndex(prevIndex => (prevIndex - 1 + totalImages) % totalImages);
  };

  useEffect(() => {
    if (!modeldata || modeldata.length === 0) {
      console.warn('modeldata is empty or undefined');
      return;
    }

    const item = modeldata[0];

    if (selectedImageIndex === 0) {
      // Set CoverImage
      const coverImageUrl = item?.attributes?.CoverImage?.data?.attributes?.url;
      if (coverImageUrl) {
        setSelectedImagePath({
          url: coverImageUrl,
          id: item.id,
          default: true
        });
      } else {
        console.warn('Cover image not found');
      }
    } else {
      // Set MultipleImage
      const imageIndex = selectedImageIndex - 1;
      const selectedImage = item?.attributes?.MultipleImage?.data?.[imageIndex];
      if (selectedImage?.attributes?.url) {
        setSelectedImagePath({
          url: selectedImage.attributes.url,
          id: item.id,
          default: true
        });
      } else {
        console.warn('Multiple image not found at index', imageIndex);
      }
    }
  }, [selectedImageIndex, modeldata]);

  const handleOpen = (value, prdcd) => {
    setOpenp(true);
    setId(prdcd);
    const filteredData = data123?.filter(item => item.id === prdcd);
    if (filteredData.length > 0) {
      setmodeldata(filteredData);
    } else {
      console.warn('No data found for the selected product ID:', prdcd);
      setmodeldata([]);
    }
  };

  // console.log("Product :", id, modeldata)
  const handleClose = () => {
    setmodeldata(modeldata);
    setId(null);
    setOpenp(false);
  };

  const [finShow, setFinShow] = useState(false);
  const [sizeshow, setSizeShow] = useState(false);
  const [productCosts, setProductCosts] = useState({});
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${globalIP}/api/company-details`);
      const json = await response.json();
      const extractedData = json.data[0].attributes.FreeSize;
      setSizeShow(extractedData);
      setFinShow(json.data[0].attributes.setFinish);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const displayData = action === 'View' ? viewData : data123;
  const totalProducts =
    action === 'View' ? viewMeta?.pagination?.total : meteData?.pagination?.total;
  const [allFairIds, setAllFairIds] = useState([]);
  const fetchData = async () => {
    if (!fairname?.length || isLoading) return;

    setIsLoading(true);
    setDisableUI(true);

    try {
      const fairCode = fairname[0]?.value;
      let products = [];
      let meta = {};

      // =====================================================
      // 🟢 VIEW & REMOVE FROM BUCKET
      // =====================================================
      if (action === 'View' || action === 'Remove from bucket') {
        // 1️⃣ Fetch ALL fair-product-masters for filtering
        const fetchAllFairProducts = async () => {
          let allFairData = [];
          let currentPage = 1;
          let hasMore = true;
          const batchSize = 100;

          while (hasMore) {
            const resp = await axios.get(
              `${globalIP}/api/fair-product-masters` +
                `?filters[faircode][$eq]=${fairCode}` +
                `&pagination[page]=${currentPage}` +
                `&pagination[pageSize]=${batchSize}`
            );

            const data = resp.data.data || [];
            allFairData = allFairData.concat(data);

            const totalPages = resp.data.meta?.pagination?.pageCount || 1;
            hasMore = currentPage < totalPages;
            currentPage++;
          }

          return allFairData;
        };

        const allFairData = await fetchAllFairProducts();

        if (!allFairData.length) {
          setData123([]);
          setMeteData({
            pagination: {
              total: 0,
              page: 1,
              pageSize,
              pageCount: 0
            }
          });
          setAllFairIds([]);
          allMatchingIds.current = [];
          return;
        }

        // 2️⃣ Separate numeric IDs & ProductCodes from ALL fair products
        const numericIds = [];
        const productCodes = [];

        allFairData.forEach(f => {
          const raw = f.attributes?.prdcd;
          if (!raw) return;

          const clean = String(raw).trim();
          if (!isNaN(clean)) numericIds.push(clean);
          else productCodes.push(clean);
        });

        // 3️⃣ Build filters for ALL products
        const filters = [];

        numericIds.forEach(id => {
          filters.push(`filters[$or][0][id][$in][]=${id}`);
        });

        productCodes.forEach(code => {
          filters.push(`filters[$or][1][ProductCode][$in][]=${encodeURIComponent(code)}`);
        });

        // 4️⃣ Add search filter if present
        if (searchQuery?.trim()) {
          filters.push(`filters[$and][0][$or][0][ProductName][$containsi]=${searchQuery.trim()}`);
          filters.push(`filters[$and][0][$or][1][ProductId][$containsi]=${searchQuery.trim()}`);
          filters.push(`filters[$and][0][$or][2][SearchKeyword][$containsi]=${searchQuery.trim()}`);
        }

        // 5️⃣ Fetch ALL matching products
        const fetchAllProducts = async () => {
          let allProducts = [];

          // If we have too many IDs, fetch in chunks
          const maxIdsPerRequest = 50; // Adjust based on your URL length limits
          const totalIds = numericIds.length + productCodes.length;

          if (totalIds > maxIdsPerRequest) {
            // Split into chunks
            const numericChunks = [];
            const productCodeChunks = [];

            for (let i = 0; i < numericIds.length; i += maxIdsPerRequest) {
              numericChunks.push(numericIds.slice(i, i + maxIdsPerRequest));
            }

            for (let i = 0; i < productCodes.length; i += maxIdsPerRequest) {
              productCodeChunks.push(productCodes.slice(i, i + maxIdsPerRequest));
            }

            // Fetch for each chunk
            for (const numChunk of numericChunks) {
              let page = 1;
              let hasMore = true;

              while (hasMore) {
                const chunkFilters = [];
                numChunk.forEach(id => chunkFilters.push(`filters[$or][0][id][$in][]=${id}`));

                if (searchQuery?.trim()) {
                  const search = searchQuery.trim();
                  chunkFilters.push(`filters[$and][0][$or][0][ProductName][$containsi]=${search}`);
                  chunkFilters.push(`filters[$and][0][$or][1][ProductId][$containsi]=${search}`);
                  chunkFilters.push(
                    `filters[$and][0][$or][2][SearchKeyword][$containsi]=${search}`
                  );
                }

                const resp = await axios.get(
                  `${globalIP}/api/products?populate=*&${chunkFilters.join('&')}` +
                    `&pagination[page]=${page}&pagination[pageSize]=100`
                );

                allProducts = allProducts.concat(resp.data.data || []);
                hasMore = page < (resp.data.meta?.pagination?.pageCount || 1);
                page++;
              }
            }

            for (const codeChunk of productCodeChunks) {
              let page = 1;
              let hasMore = true;

              while (hasMore) {
                const chunkFilters = [];
                codeChunk.forEach(code =>
                  chunkFilters.push(
                    `filters[$or][0][ProductCode][$in][]=${encodeURIComponent(code)}`
                  )
                );

                if (searchQuery?.trim()) {
                  const search = searchQuery.trim();
                  chunkFilters.push(`filters[$and][0][$or][0][ProductName][$containsi]=${search}`);
                  chunkFilters.push(`filters[$and][0][$or][1][ProductId][$containsi]=${search}`);
                  chunkFilters.push(
                    `filters[$and][0][$or][2][SearchKeyword][$containsi]=${search}`
                  );
                }

                const resp = await axios.get(
                  `${globalIP}/api/products?populate=*&${chunkFilters.join('&')}` +
                    `&pagination[page]=${page}&pagination[pageSize]=100`
                );

                allProducts = allProducts.concat(resp.data.data || []);
                hasMore = page < (resp.data.meta?.pagination?.pageCount || 1);
                page++;
              }
            }
          } else {
            // Normal fetch when IDs are reasonable
            let page = 1;
            let hasMore = true;

            while (hasMore) {
              const resp = await axios.get(
                `${globalIP}/api/products?populate=*&${filters.join('&')}` +
                  `&pagination[page]=${page}&pagination[pageSize]=100`
              );

              allProducts = allProducts.concat(resp.data.data || []);
              hasMore = page < (resp.data.meta?.pagination?.pageCount || 1);
              page++;
            }
          }

          // Remove duplicates
          const uniqueProducts = [];
          const seenIds = new Set();

          allProducts.forEach(product => {
            if (!seenIds.has(product.id)) {
              seenIds.add(product.id);
              uniqueProducts.push(product);
            }
          });

          return uniqueProducts;
        };

        let allProducts = await fetchAllProducts();

        // 6️⃣ Attach fairId to all products
        const fairMap = new Map(allFairData.map(f => [String(f.attributes?.prdcd), f.id]));

        allProducts = allProducts.map(p => ({
          ...p,
          fairId: fairMap.get(String(p.id)) || fairMap.get(String(p.attributes?.ProductCode))
        }));

        // 7️⃣ Apply filters
        allProducts = applyAllFilters(allProducts);

        // ✅ SEARCH FILTER WITH TRIM (client-side)
        if (searchQuery.trim().length > 0) {
          const q = searchQuery.trim().toLowerCase();
          allProducts = allProducts.filter(p => {
            const a = p.attributes;
            return (
              a.ProductId?.toLowerCase().includes(q) ||
              a.ProductName?.toLowerCase().includes(q) ||
              a.SearchKeyword?.toLowerCase().includes(q) ||
              a.Description?.toLowerCase().includes(q) ||
              a.CategoryName?.toLowerCase().includes(q) ||
              a.ProductTypeName?.toLowerCase().includes(q) ||
              a.ColorName?.toLowerCase().includes(q) ||
              a.FinishName?.toLowerCase().includes(q)
            );
          });
        }

        // 8️⃣ Store all fair IDs for "Select All"
        const filteredFairIds = allProducts
          .map(p => p.fairId)
          .filter(id => id !== undefined && id !== null);

        setAllFairIds(filteredFairIds);
        allMatchingIds.current = filteredFairIds;

        // 9️⃣ Client-side pagination - FIXED
        const total = allProducts.length;
        const totalPages = Math.ceil(total / pageSize);

        // Ensure currentPage doesn't exceed available pages
        const validPage = Math.min(currentPage, Math.max(1, totalPages));

        const start = (validPage - 1) * pageSize;
        const end = start + pageSize;
        const paginated = allProducts.slice(start, end);

        setData123(paginated);
        setMeteData({
          pagination: {
            total,
            page: validPage,
            pageSize,
            pageCount: totalPages
          }
        });

        console.log(
          'VIEW/REMOVE - Total Products:',
          total,
          'Page:',
          validPage,
          'PageCount:',
          totalPages,
          'Showing:',
          paginated.length
        );
      }

      // =====================================================
      // 🔵 ADD TO BUCKET - FIXED WITH CLIENT-SIDE EXCLUSION
      // =====================================================
      if (action === 'Add to Bucket') {
        // 1️⃣ Get total count of fair products
        const fairCountResp = await axios.get(
          `${globalIP}/api/fair-product-masters` +
            `?filters[faircode][$eq]=${fairCode}` +
            `&pagination[pageSize]=1` +
            `&fields[0]=id`
        );

        const totalFairProducts = fairCountResp.data.meta?.pagination?.total || 0;

        // 2️⃣ Fetch ALL fair products in batches (for client-side exclusion)
        const fetchAllExclusionIds = async () => {
          const allPrdCodes = [];
          const batchSize = 100;
          const totalPages = Math.ceil(totalFairProducts / batchSize);

          for (let page = 1; page <= totalPages; page++) {
            const resp = await axios.get(
              `${globalIP}/api/fair-product-masters` +
                `?filters[faircode][$eq]=${fairCode}` +
                `&pagination[page]=${page}` +
                `&pagination[pageSize]=${batchSize}` +
                `&fields[0]=prdcd`
            );
            allPrdCodes.push(...resp.data.data.map(f => String(f.attributes?.prdcd || '').trim()));
          }
          return allPrdCodes;
        };

        const fairRaw = await fetchAllExclusionIds();

        // 3️⃣ Create exclusion Set for fast lookup
        const exclusionSet = new Set(fairRaw);

        // 4️⃣ Build filters WITHOUT exclusions (we'll filter client-side)
        const filters = [];

        // Only Authorized products
        filters.push(`filters[Authorized][$eq]=Authorised`);

        // Search filter
        if (searchQuery?.trim()) {
          const search = encodeURIComponent(searchQuery.trim());
          filters.push(`filters[$or][0][ProductName][$containsi]=${search}`);
          filters.push(`filters[$or][1][ProductId][$containsi]=${search}`);
          filters.push(`filters[$or][2][SearchKeyword][$containsi]=${search}`);
        }

        // 5️⃣ Fetch ALL authorized products in batches
        const fetchAllAuthorizedProducts = async () => {
          let allProducts = [];
          let currentPage = 1;
          let hasMore = true;
          const batchSize = 100;

          while (hasMore) {
            const resp = await axios.get(
              `${globalIP}/api/products?populate=*` +
                `&${filters.join('&')}` +
                `&pagination[page]=${currentPage}` +
                `&pagination[pageSize]=${batchSize}`
            );

            const products = resp.data.data || [];
            allProducts = allProducts.concat(products);

            const totalPages = resp.data.meta?.pagination?.pageCount || 1;
            hasMore = currentPage < totalPages;
            currentPage++;
          }

          return allProducts;
        };

        let allProducts = await fetchAllAuthorizedProducts();

        // 6️⃣ CLIENT-SIDE EXCLUSION - Filter out products in bucket
        allProducts = allProducts.filter(p => {
          const productId = String(p.id);
          const productCode = String(p.attributes?.ProductCode || '');

          return !exclusionSet.has(productId) && !exclusionSet.has(productCode);
        });

        // 7️⃣ Apply additional filters
        allProducts = applyAllFilters(allProducts);
        // ✅ SEARCH FILTER WITH TRIM (client-side)
        if (searchQuery.trim().length > 0) {
          const q = searchQuery.trim().toLowerCase();
          allProducts = allProducts.filter(p => {
            const a = p.attributes;
            return (
              a.ProductId?.toLowerCase().includes(q) ||
              a.ProductName?.toLowerCase().includes(q) ||
              a.SearchKeyword?.toLowerCase().includes(q) ||
              a.Description?.toLowerCase().includes(q) ||
              a.CategoryName?.toLowerCase().includes(q) ||
              a.ProductTypeName?.toLowerCase().includes(q) ||
              a.ColorName?.toLowerCase().includes(q) ||
              a.FinishName?.toLowerCase().includes(q)
            );
          });
        }
        // 8️⃣ Store all filtered products for "Select All"
        const allProductIds = allProducts.map(p => p.id);
        allMatchingIds.current = allProductIds;
        setAllFairIds(allProductIds);

        // 9️⃣ Client-side pagination
        const total = allProducts.length;
        const totalPages = Math.ceil(total / pageSize);

        // Ensure currentPage doesn't exceed available pages
        const validPage = Math.min(currentPage, Math.max(1, totalPages));

        const start = (validPage - 1) * pageSize;
        const end = start + pageSize;
        const paginated = allProducts.slice(start, end);

        setData123(paginated);
        setMeteData({
          pagination: {
            total,
            page: validPage,
            pageSize,
            pageCount: totalPages
          }
        });

        console.log({
          total,
          page: currentPage,
          pageSize,
          showing: paginated.length
        });
      }
    } catch (err) {
      console.error('Fetch error:', err);
    } finally {
      setIsLoading(false);
      setDisableUI(false);
    }
  };
  // const fetchData = async () => {
  //   if (!fairname?.length || isLoading) return;

  //   setIsLoading(true);
  //   setDisableUI(true);

  //   try {
  //     const fairCode = fairname[0]?.value;
  //     let products = [];
  //     let meta = {};

  //     // =====================================================
  //     // 🟢 VIEW & REMOVE FROM BUCKET
  //     // =====================================================
  //     if (action === 'View' || action === 'Remove from bucket') {
  //       // 1️⃣ Get ALL fair-product-masters (not paginated)
  //       const fairResp = await axios.get(
  //         `${globalIP}/api/fair-product-masters` +
  //           `?filters[faircode][$eq]=${fairCode}` +
  //           `&pagination[pageSize]=100000` // Fetch ALL for client-side filtering
  //       );

  //       const fairData = fairResp.data.data || [];

  //       if (!fairData.length) {
  //         setData123([]);
  //         setMeteData({ pagination: { total: 0 } });
  //         setAllFairIds([]);
  //         allMatchingIds.current = [];
  //         return;
  //       }

  //       // 2️⃣ Separate numeric IDs & ProductCodes
  //       const numericIds = [];
  //       const productCodes = [];

  //       fairData.forEach(f => {
  //         const raw = f.attributes?.prdcd;
  //         if (!raw) return;

  //         const clean = String(raw).trim();
  //         if (!isNaN(clean)) numericIds.push(clean);
  //         else productCodes.push(clean);
  //       });

  //       // 3️⃣ Build OR filter correctly
  //       const filters = [];

  //       numericIds.forEach(id => {
  //         filters.push(`filters[$or][0][id][$in][]=${id}`);
  //       });

  //       productCodes.forEach(code => {
  //         filters.push(`filters[$or][1][ProductCode][$in][]=${encodeURIComponent(code)}`);
  //       });

  //       const productResp = await axios.get(
  //         `${globalIP}/api/products?populate=*` +
  //           `&${filters.join('&')}` +
  //           `&pagination[pageSize]=100000` // Fetch ALL
  //       );

  //       products = productResp.data.data || [];

  //       // attach fairId
  //       const fairMap = new Map(fairData.map(f => [String(f.attributes?.prdcd), f.id]));

  //       products = products.map(p => ({
  //         ...p,
  //         fairId: fairMap.get(String(p.id)) || fairMap.get(String(p.attributes?.ProductCode))
  //       }));

  //       // ✅ Apply all filters (same as fetchDataBasedOnAction)
  //       products = applyAllFilters(products);

  //       // ✅ SEARCH FILTER WITH TRIM (client-side)
  //       if (searchQuery.trim().length > 0) {
  //         const q = searchQuery.trim().toLowerCase();
  //         products = products.filter(p => {
  //           const a = p.attributes;
  //           return (
  //             a.ProductId?.toLowerCase().includes(q) ||
  //             a.ProductName?.toLowerCase().includes(q) ||
  //             a.SearchKeyword?.toLowerCase().includes(q) ||
  //             a.Description?.toLowerCase().includes(q) ||
  //             a.CategoryName?.toLowerCase().includes(q) ||
  //             a.ProductTypeName?.toLowerCase().includes(q) ||
  //             a.ColorName?.toLowerCase().includes(q) ||
  //             a.FinishName?.toLowerCase().includes(q)
  //           );
  //         });
  //       }

  //       // ✅ Set allMatchingIds AFTER all filters
  //       const fairIds = products.map(p => p.fairId).filter(Boolean);
  //       allMatchingIds.current = fairIds;
  //       setAllFairIds(fairIds);

  //       // ✅ CLIENT-SIDE PAGINATION (same as Add to Bucket)
  //       const total = products.length;
  //       const start = (currentPage - 1) * pageSize;
  //       const end = start + pageSize;
  //       const paginated = products.slice(start, end);

  //       setData123(paginated);
  //       setMeteData({
  //         pagination: {
  //           total,
  //           page: currentPage,
  //           pageSize,
  //           pageCount: Math.ceil(total / pageSize)
  //         }
  //       });

  //       console.log(
  //         'VIEW/REMOVE - Total:',
  //         total,
  //         'Page:',
  //         currentPage,
  //         'Showing:',
  //         paginated.length
  //       );
  //     }

  //     // =====================================================
  //     // 🔵 ADD TO BUCKET
  //     // =====================================================
  //     if (action === 'Add to Bucket') {
  //       // 1️⃣ Get ALL fair products (only prdcd)
  //       const fairResp = await axios.get(
  //         `${globalIP}/api/fair-product-masters` +
  //           `?filters[faircode][$eq]=${fairCode}` +
  //           `&pagination[pageSize]=1000`
  //       );

  //       const fairRaw = fairResp.data.data.map(f => String(f.attributes?.prdcd || '').trim());

  //       // 2️⃣ Separate numeric IDs and ProductCodes
  //       const numericIds = [];
  //       const productCodes = [];

  //       fairRaw.forEach(val => {
  //         if (!val) return;

  //         if (!isNaN(val)) {
  //           numericIds.push(val);
  //         } else {
  //           productCodes.push(val);
  //         }
  //       });

  //       const filters = [];

  //       // 3️⃣ Exclude numeric product IDs
  //       if (numericIds.length) {
  //         numericIds.forEach(id => {
  //           filters.push(`filters[id][$notIn][]=${id}`);
  //         });
  //       }

  //       // 4️⃣ Exclude PRD codes safely
  //       if (productCodes.length) {
  //         productCodes.forEach(code => {
  //           filters.push(`filters[ProductCode][$notIn][]=${encodeURIComponent(code)}`);
  //         });
  //       }

  //       // 5️⃣ Always Authorized only
  //       filters.push(`filters[Authorized][$eq]=Authorised`);

  //       // 6️⃣ Fetch ALL matching products (without pagination first)
  //       const productResp = await axios.get(
  //         `${globalIP}/api/products?populate=*` +
  //           `&${filters.join('&')}` +
  //           `&pagination[pageSize]=100000` // Fetch all for client-side filtering
  //       );

  //       let fetchedProducts = productResp.data.data || [];
  //       setAllFilteredProducts(fetchedProducts);

  //       // ✅ Apply all filters (same as fetchDataBasedOnAction)
  //       fetchedProducts = applyAllFilters(fetchedProducts);
  //       allMatchingIds.current = fetchedProducts.map(p => p.id);

  //       // ✅ SEARCH FILTER WITH TRIM (client-side)
  //       if (searchQuery.trim().length > 0) {
  //         const q = searchQuery.trim().toLowerCase();
  //         fetchedProducts = fetchedProducts.filter(p => {
  //           const a = p.attributes;
  //           return (
  //             a.ProductId?.toLowerCase().includes(q) ||
  //             a.ProductName?.toLowerCase().includes(q) ||
  //             a.SearchKeyword?.toLowerCase().includes(q) ||
  //             a.Description?.toLowerCase().includes(q) ||
  //             a.CategoryName?.toLowerCase().includes(q) ||
  //             a.ProductTypeName?.toLowerCase().includes(q) ||
  //             a.ColorName?.toLowerCase().includes(q) ||
  //             a.FinishName?.toLowerCase().includes(q)
  //           );
  //         });
  //       }

  //       // ✅ Pagination (client-side)
  //       const total = fetchedProducts.length;
  //       const start = (currentPage - 1) * pageSize;
  //       const end = start + pageSize;
  //       const paginated = fetchedProducts.slice(start, end);

  //       setData123(paginated);
  //       setMeteData({
  //         pagination: {
  //           total,
  //           page: currentPage,
  //           pageSize,
  //           pageCount: Math.ceil(total / pageSize)
  //         }
  //       });

  //       // 🆕 For "Add to Bucket", set all IDs for select all
  //       setAllFairIds(allMatchingIds.current);
  //       console.log({ total, page: currentPage, pageSize });
  //     }
  //   } catch (err) {
  //     console.error('Fetch error:', err);
  //   } finally {
  //     setIsLoading(false);
  //     setDisableUI(false);
  //   }
  // };
  // const fetchData = async () => {
  //   if (!fairname?.length || isLoading) return;

  //   setIsLoading(true);
  //   setDisableUI(true);

  //   try {
  //     const fairCode = fairname[0]?.value;
  //     let products = [];
  //     let meta = {};

  //     // =====================================================
  //     // 🟢 VIEW & REMOVE FROM BUCKET
  //     // =====================================================
  //     if (action === 'View' || action === 'Remove from bucket') {
  //       // 1️⃣ Get paginated fair-product-masters
  //       const fairResp = await axios.get(
  //         `${globalIP}/api/fair-product-masters` +
  //           `?filters[faircode][$eq]=${fairCode}` +
  //           `&pagination[page]=${currentPage}` +
  //           `&pagination[pageSize]=${pageSize}`
  //       );

  //       const fairData = fairResp.data.data || [];
  //       meta = fairResp.data.meta;
  //       const allFairResp = await axios.get(
  //         `${globalIP}/api/fair-product-masters` +
  //           `?filters[faircode][$eq]=${fairCode}` +
  //           `&pagination[pageSize]=${meta?.pagination?.total || 1000000}` +
  //           `&fields[0]=id`
  //       );

  //       const allIds = allFairResp.data.data.map(f => f.id);
  //       setAllFairIds(allIds);
  //       if (!fairData.length) {
  //         setData123([]);
  //         setMeteData(meta);
  //         return;
  //       }

  //       // 2️⃣ Separate numeric IDs & ProductCodes
  //       const numericIds = [];
  //       const productCodes = [];

  //       fairData.forEach(f => {
  //         const raw = f.attributes?.prdcd;
  //         if (!raw) return;

  //         const clean = String(raw).trim();
  //         if (!isNaN(clean)) numericIds.push(clean);
  //         else productCodes.push(clean);
  //       });

  //       // 3️⃣ Build OR filter correctly
  //       const filters = [];

  //       numericIds.forEach(id => {
  //         filters.push(`filters[$or][0][id][$in][]=${id}`);
  //       });

  //       productCodes.forEach(code => {
  //         filters.push(`filters[$or][1][ProductCode][$in][]=${encodeURIComponent(code)}`);
  //       });

  //       if (searchQuery?.trim()) {
  //         filters.push(`filters[$and][0][$or][0][ProductName][$containsi]=${searchQuery.trim()}`);
  //       }

  //       const productResp = await axios.get(
  //         `${globalIP}/api/products?populate=*` +
  //           `&${filters.join('&')}` +
  //           `&pagination[pageSize]=${pageSize}`
  //       );

  //       products = productResp.data.data || [];

  //       // attach fairId
  //       const fairMap = new Map(fairData.map(f => [String(f.attributes?.prdcd), f.id]));

  //       products = products.map(p => ({
  //         ...p,
  //         fairId: fairMap.get(String(p.id)) || fairMap.get(String(p.attributes?.ProductCode))
  //       }));

  //       setData123(products);
  //       setMeteData(meta);
  //     }

  //     // =====================================================
  //     // 🔵 ADD TO BUCKET
  //     // =====================================================
  //     if (action === 'Add to Bucket') {
  //       // 1️⃣ Get ALL fair products (only prdcd)
  //       const fairResp = await axios.get(
  //         `${globalIP}/api/fair-product-masters` +
  //           `?filters[faircode][$eq]=${fairCode}` +
  //           `&pagination[pageSize]=1000`
  //       );

  //       const fairRaw = fairResp.data.data.map(f => String(f.attributes?.prdcd || '').trim());

  //       // 2️⃣ Separate numeric IDs and ProductCodes
  //       const numericIds = [];
  //       const productCodes = [];

  //       fairRaw.forEach(val => {
  //         if (!val) return;

  //         if (!isNaN(val)) {
  //           numericIds.push(val);
  //         } else {
  //           productCodes.push(val);
  //         }
  //       });

  //       const filters = [];

  //       // 3️⃣ Exclude numeric product IDs
  //       if (numericIds.length) {
  //         numericIds.forEach(id => {
  //           filters.push(`filters[id][$notIn][]=${id}`);
  //         });
  //       }

  //       // 4️⃣ Exclude PRD codes safely
  //       if (productCodes.length) {
  //         productCodes.forEach(code => {
  //           filters.push(`filters[ProductCode][$notIn][]=${encodeURIComponent(code)}`);
  //         });
  //       }

  //       // 5️⃣ Always Authorized only
  //       filters.push(`filters[Authorized][$eq]=Authorised`);

  //       // 6️⃣ Search filter
  //       if (searchQuery?.trim()) {
  //         const search = encodeURIComponent(searchQuery.trim());

  //         filters.push(`filters[$or][0][ProductName][$containsi]=${search}`);
  //         filters.push(`filters[$or][1][ProductId][$containsi]=${search}`);
  //       }

  //       // 7️⃣ Fetch products with proper pagination
  //       const productResp = await axios.get(
  //         `${globalIP}/api/products?populate=*` +
  //           `&${filters.join('&')}` +
  //           `&pagination[page]=${currentPage}` +
  //           `&pagination[pageSize]=${pageSize}`
  //       );

  //       setData123(productResp.data.data || []);
  //       setMeteData(productResp.data.meta);

  //       // 🆕 For "Add to Bucket", fetch all product IDs for select all
  //       const allProductResp = await axios.get(
  //         `${globalIP}/api/products` +
  //           `?${filters.join('&')}` +
  //           `&pagination[pageSize]=${productResp.data.meta?.pagination?.total || 100000}` +
  //           `&fields[0]=id`
  //       );

  //       const allIds = allProductResp.data.data.map(p => p.id);
  //       setAllFairIds(allIds);
  //       console.log(productResp.data.meta);
  //     }
  //   } catch (err) {
  //     console.error('Fetch error:', err);
  //   } finally {
  //     setIsLoading(false);
  //     setDisableUI(false);
  //   }
  // };
  useEffect(() => {
    if (!fairname?.length) return;

    setSelectedRowIds([]);
    setData123([]);

    fetchData();
  }, [
    fairname,
    action,
    currentPage,
    debouncedSearchQuery,
    searchQuery.trim(),
    selectedCategoryCode,
    selectedProductType,
    selectedColor,
    selectedFinish,
    selectedhsn,
    selectedBuyer,
    selectedSearch,
    selectedAlias,
    selectedpron,
    selectedpd,
    selectedmade,
    selectedsku
  ]);

  return (
    <>
      <Container className="main">
        <div
          style={{
            justifyContent: 'space-between',
            width: '-webkit-fill-available',
            position: 'fixed',
            height: '195px',
            background: '#fff',
            zIndex: 1
          }}
        >
          <Stack className="table-toolbar" justifyContent="space-between">
            <Stack direction="column" alignItems="flex-start">
              <Stack direction="column" alignItems="flex-start">
                <h3 className="title">Manage Fair</h3>
                <Breadcrumb>
                  <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                  <Breadcrumb.Item active>Fair</Breadcrumb.Item>
                </Breadcrumb>
              </Stack>
              <Stack spacing={5} alignItems="flex-end">
                <Stack direction="column" alignItems="flex-start">
                  <label>Current Fair Name</label>
                  <div id="custom-container" style={{ position: 'relative' }}>
                    <SelectPicker
                      data={fairname}
                      value={fairname.length > 0 ? fairname[0].label : ''}
                      labelKey="label"
                      valueKey="label"
                      style={{ width: 150 }}
                      cleanable={false}
                      onChange={value => setFairName(value)}
                      container={() => document.getElementById('custom-container')}
                    />
                  </div>
                </Stack>

                <Stack direction="column" alignItems="flex-start">
                  <label>Action</label>
                  <div id="custom-container" style={{ position: 'relative' }}>
                    <SelectPicker
                      data={data}
                      value={action}
                      onChange={value => {
                        setAction(value);
                        setCurrentPage(1);
                        setSelectedRowIds([]);
                      }}
                      labelKey="label"
                      valueKey="label"
                      style={{ width: 150 }}
                      cleanable={false}
                      container={() => document.getElementById('custom-container')}
                    />
                  </div>
                </Stack>
                {shfilter &&
                  (action === 'Add to Bucket' ||
                    action === 'Remove from bucket' ||
                    action === 'View') && (
                    <Stack spacing={5}>
                      <Stack direction="column" alignItems="flex-start">
                        <label>{`${label[0]?.attributes.Category}`}</label>
                        <CheckPicker
                          data={categorydata}
                          value={selectedCategoryCode}
                          onChange={handleCategoryChange}
                          placeholder={`${label[0]?.attributes.Category}`}
                          style={{ width: 200 }}
                          menuStyle={{ maxWidth: 250 }}
                        />
                      </Stack>
                      <Stack direction="column" alignItems="flex-start">
                        <label>{`${label[0]?.attributes.ProductType}`}</label>
                        <CheckPicker
                          data={productypedata}
                          placeholder={`${label[0]?.attributes.ProductType}`}
                          value={selectedProductType}
                          onChange={handleProductTypeChange}
                          style={{ width: 150 }}
                          menuStyle={{ maxWidth: 250 }}
                        />
                      </Stack>

                      <Button
                        appearance="default"
                        active
                        onClick={handleFilterDrawerOpen} // ✅ Changed from setOpenD(true)
                        style={{ marginTop: '18px' }}
                      >
                        More Filter
                      </Button>
                    </Stack>
                  )}
                <Stack
                  direction="column"
                  spacing={4}
                  alignItems="flex-start"
                  style={{ paddingBottom: 2 }}
                >
                  <b>Total Products: {meteData?.pagination?.total ?? 0}</b>
                </Stack>
              </Stack>
            </Stack>
            <Stack direction="column" spacing={20} alignItems="flex-end" justifyContent="flex-end">
              <InputGroup inside>
                {/* <Input
                placeholder="Search"
                value={searchQuery}
                onChange={value => handleSearch(value)}
              /> */}
                <Input
                  placeholder="Search"
                  type="text"
                  value={searchQuery}
                  onChange={value => {
                    setSearchQuery(value);
                  }}
                  onKeyDown={event => {
                    if (event.key === 'Enter') {
                      // Trim search query before searching
                      const trimmedQuery = searchQuery.trim();
                      setSearchQuery(trimmedQuery);
                      setCurrentPage(1);
                      setData123([]);
                      setSelectedRowIds([]);
                    }
                  }}
                />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>

              <Stack spacing={5}>
                {/* Unified Select All Checkbox */}
                {action === 'Add to Bucket' && displayData?.length > 0 && (
                  <Checkbox
                    indeterminate={
                      selectedRowIds.length > 0 &&
                      selectedRowIds.length < allMatchingIds.current.length
                    }
                    checked={
                      allMatchingIds.current.length > 0 &&
                      selectedRowIds.length === allMatchingIds.current.length
                    }
                    onChange={handleCheckAll}
                  >
                    Select all
                  </Checkbox>
                )}

                {(action === 'Remove from bucket' || action === 'View') && data123?.length > 0 && (
                  <Checkbox
                    indeterminate={
                      selectedRowIds.length > 0 && selectedRowIds.length < allFairIds.length
                    }
                    checked={allFairIds.length > 0 && selectedRowIds.length === allFairIds.length}
                    onChange={(value, checked) => setSelectedRowIds(checked ? allFairIds : [])}
                  >
                    Select all
                  </Checkbox>
                )}

                {/* Actions when rows are selected */}
                {selectedRowIds.length > 0 &&
                  action !== 'Remove from bucket' &&
                  action !== 'Add to Bucket' && (
                    <Stack spacing={5}>
                      <Button
                        appearance="default"
                        active
                        onClick={() => downloadExcelData(csvData)}
                        disabled={isLoadingFairData || iscsvLoading}
                        loading={isLoadingFairData || iscsvLoading}
                      >
                        Excel
                      </Button>
                      <IconButton
                        icon={<QrcodeIcon />}
                        size="md"
                        onClick={() => setOpenq(true)}
                        disabled={isLoadingFairData}
                        loading={isLoadingFairData}
                        active
                      />
                    </Stack>
                  )}

                {/* Add to Bucket filter toggle */}
                {/* {action === 'Add to Bucket' && (
                  <Button appearance="default" active onClick={() => setShfilter(!shfilter)}>
                    {shfilter ? 'Hide filter' : 'Show filter'}
                  </Button>
                )} */}

                {/* Filter toggle for all actions except View (or include View if needed) */}
                {(action === 'Add to Bucket' ||
                  action === 'Remove from bucket' ||
                  action === 'View') && (
                  <Button
                    appearance="default"
                    active
                    onClick={() => {
                      setShfilter(!shfilter);
                      fetchData1();
                      fetchData2();
                    }}
                  >
                    {shfilter ? 'Hide filter' : 'Show filter'}
                  </Button>
                )}

                {/* Always visible Add Fair/Show button */}
                <Button appearance="primary" color="cyan" onClick={() => setOpen(true)}>
                  Add Fair/Show
                </Button>
              </Stack>
            </Stack>
          </Stack>
          <Divider style={{ marginTop: '4px', marginBottom: '5px' }} />
        </div>
        <div className="row" style={{ marginTop: '178px' }}>
          {isLoading && !searchQuery && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'rgba(255,255,255,0.7)',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Loader center size="md" speed="fast" content="Loading..." />
            </div>
          )}

          <Panel
            style={{
              pointerEvents: disableUI ? 'none' : 'auto',
              opacity: disableUI ? 0.5 : 1,
              display: 'flex',
              flexDirection: 'column',
              height: 'calc(100vh - 200px)', // Adjust card height as needed
              overflow: 'auto'
            }}
          >
            {/* Scrollable Grid */}
            <div className="flex-1 overflow-auto p-4">
              {data123?.length > 0 ? (
                <FlexboxGrid justify="start" style={{ textAlign: 'center' }}>
                  {getFilteredData().map(item => (
                    <FlexboxGrid.Item
                      as={Col}
                      colspan={24}
                      md={6}
                      className="data-tbl-img"
                      key={item.id}
                    >
                      <Panel
                        className="box"
                        bordered
                        bodyFill
                        style={{ display: 'inline-block', width: '100%', height: '296px' }}
                      >
                        <Stack>
                          <Stack>
                            <Checkbox
                              value={action === 'Add to Bucket' ? item.id : item.fairId}
                              checked={selectedRowIds.includes(
                                action === 'Add to Bucket' ? item.id : item.fairId
                              )}
                              onChange={(value, checked) =>
                                handleCheckboxChange(
                                  action === 'Add to Bucket' ? item.id : item.fairId,
                                  checked
                                )
                              }
                            />
                          </Stack>
                        </Stack>

                        <div
                          className="image-containerm"
                          onClick={() => {
                            const key = action === 'Remove from bucket' ? item.fairId : item.id;
                            handleCheckboxChange(key, !selectedRowIds.includes(key));
                          }}
                        >
                          <img
                            src={`${globalIP}${item.attributes?.CoverImage?.data?.attributes?.url}`}
                            alt="Image"
                            className="image-style"
                          />
                        </div>

                        <div className="overlay">
                          <Link
                            to={{
                              pathname: `/${ugr}/productView`,
                              search: `?id=${item.id}&variantId=${item.attributes.Variant_Id}&val=${
                                page === 'variant' ? 0 : 1
                              }`
                            }}
                            className="link"
                            target="_blank"
                          >
                            <Button style={{ background: 'rgba(0, 0, 0, -0.5)', color: 'white' }}>
                              Product Details
                            </Button>
                          </Link>
                        </div>

                        <Panel>
                          <b>Product : {item.attributes.ProductName} </b>
                          <p>Alias : {item.attributes.ProductId}</p>
                        </Panel>
                      </Panel>
                    </FlexboxGrid.Item>
                  ))}
                </FlexboxGrid>
              ) : (
                isLoading && <Loader center size="md" speed="fast" content="loading..." />
              )}
            </div>

            {/* Sticky Pagination */}
            <div
              style={{
                position: 'fixed',
                width: '100%',
                bottom: 0,
                background: '#fff',
                zIndex: 10,
                padding: '20px',
                display: 'flex',
                justifyContent: 'center',
                borderTop: '1px solid #eee'
              }}
            >
              <Pagination
                prev
                next
                first
                last
                ellipsis
                boundaryLinks
                maxButtons={5}
                size="md"
                layout={['total', '|', 'pager']} // <-- removed 'limit'
                total={meteData?.pagination?.total || 0}
                limit={pageSize} // pageSize controlled only via state
                activePage={currentPage}
                onChangePage={page => setCurrentPage(page)}
              />

              <Stack
                className="copyright"
                justifyContent="flex-end"
                spacing={5}
                style={{
                  position: 'fixed',
                  bottom: '0',
                  width: '-webkit-fill-available',
                  textAlign: 'center',
                  backgroundColor: 'white',
                  paddingRight: '16px'
                }}
              >
                <p>© All Right Reserved. Product by </p>
                <p>
                  {' '}
                  <a href="https://erpdaddy.com/" target="_blank">
                    ERP Daddy Softwere Solution.
                  </a>
                </p>
              </Stack>
            </div>
          </Panel>

          {/* Notification */}
          {selectedRowIds.length > 0 &&
            (action === 'Remove from bucket' || action === 'Add to Bucket') && (
              <Notification
                type="success"
                onClose={handleCartClose}
                style={{
                  position: 'fixed',
                  top: '80%',
                  right: 20,
                  transform: 'translateY(-50%)',
                  zIndex: 9999,
                  background: '#0070a9',
                  color: 'white',
                  width: '20%'
                }}
              >
                {action === 'Remove from bucket' ? (
                  <>
                    <b style={{ color: 'white' }}> Selected Products : {selectedRowIds.length}</b>
                    <Divider />
                    <IconButton
                      icon={<TrashIcon />}
                      onClick={deleteFairProducts}
                      loading={isLoading1}
                    >
                      <b>Remove</b>
                    </IconButton>
                  </>
                ) : (
                  <>
                    <b style={{ color: 'white' }}>Add to Cart : {selectedRowIds.length}</b>
                    <Divider />
                    <Stack justifyContent="space-between">
                      <IconButton
                        icon={<ReviewPassIcon />}
                        onClick={e => submit(e, 0)}
                        loading={isLoading || loading}
                      >
                        <b>Add</b>
                      </IconButton>
                      <IconButton icon={<QrcodeIcon />} onClick={e => submit(e, 1)}>
                        <b>Add & QR</b>
                      </IconButton>
                    </Stack>
                  </>
                )}
              </Notification>
            )}
        </div>

        {(viewData?.length > 0 || data123?.length > 0) && (
          <Button ref={ref} style={{ visibility: 'hidden' }}></Button>
        )}
        {/* <Button ref={ref} style={{ visibility: 'hidden' }}></Button> */}
        <Stack justifyContent="flex-end">
          <IconButton
            size="sm"
            icon={<SortUpIcon />}
            active
            onClick={scrollToTop}
            style={{
              position: 'fixed',
              top: '90%',
              right: 16,
              transform: 'translateY(-50%)',
              zIndex: 9999
            }}
          />
        </Stack>
        <Modal open={open2} onClose={handleClose2}>
          <Modal.Body>
            <Stack direction="column">
              <Icon
                as={CheckOutlineIcon}
                color="cyan"
                style={{ fontSize: '100px', marginBottom: '20px' }}
              />
              <b>Saved Successfully</b>
            </Stack>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClose2} appearance="primary" color="cyan">
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal open={open3} onClose={handleClose3}>
          <Modal.Body>
            <Stack direction="column">
              <Icon
                as={CheckOutlineIcon}
                color="cyan"
                style={{ fontSize: '100px', marginBottom: '20px' }}
              />
              <b>Removed Successfully</b>
            </Stack>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClose3} appearance="primary" color="cyan">
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
        <Drawer size="xs" open={openD} onClose={() => setOpenD(false)} backdrop="static">
          <Drawer.Header>
            <Drawer.Title>Filter</Drawer.Title>
            <Drawer.Actions>
              <Button onClick={() => setOpenD(false)} appearance="primary" color="cyan">
                Confirm
              </Button>
            </Drawer.Actions>
          </Drawer.Header>
          <Drawer.Body>
            <Stack direction="column" alignItems="center">
              <CheckPicker
                data={aliasdata}
                placeholder={`${label[0]?.attributes.AliasCode}`}
                value={selectedAlias}
                onChange={handleAliasChange}
                style={{ width: 350, marginBottom: 20, marginTop: 20 }}
              />

              <CheckPicker
                value={selectedpron}
                onChange={handleProNameChange}
                data={proNamedata}
                placement="autoVerticalStart"
                placeholder={`${label[0]?.attributes.ProductName}`}
                style={{ width: 350, marginBottom: 20 }}
              />

              <CheckPicker
                value={selectedsku}
                onChange={handleSkuChange}
                data={skudata}
                placement="autoVerticalStart"
                placeholder={`${label[0]?.attributes.BuyerSku}`}
                style={{ width: 350, marginBottom: 20 }}
              />

              <CheckPicker
                value={selectedBuyer}
                onChange={handleBuyerChange}
                data={buyernamedata}
                placement="autoVerticalStart"
                placeholder={`${label[0]?.attributes.BuyerName}`}
                style={{ width: 350, marginBottom: 20 }}
              />

              <CheckPicker
                value={selectedFinish}
                onChange={handleFinishChange}
                data={finishdata}
                placement="autoVerticalStart"
                placeholder={`${label[0]?.attributes.finish}`}
                style={{ width: 350, marginBottom: 20 }}
                // onOpen={fetchData4}
              />

              <CheckPicker
                data={colordata}
                placeholder={`${label[0]?.attributes.color}`}
                placement="autoVerticalStart"
                value={selectedColor}
                onChange={handleColorChange}
                style={{ width: 350, marginBottom: 20 }}
                // onOpen={fetchData5}
              />

              <CheckPicker
                value={selectedSearch}
                onChange={handleSearchChange}
                data={searchdata}
                placement="autoVerticalStart"
                placeholder={`${label[0]?.attributes.searchKeyword}`}
                style={{ width: 350, marginBottom: 20 }}
              />

              <CheckPicker
                value={selectedpd}
                onChange={handleProDChange}
                data={proDdata}
                placement="autoVerticalStart"
                placeholder={`${label[0]?.attributes.ProductDesigner}`}
                style={{ width: 350, marginBottom: 20 }}
              />

              <CheckPicker
                value={selectedmade}
                onChange={handleMadeChange}
                data={madedata}
                placement="autoVerticalStart"
                placeholder={`${label[0]?.attributes.MadeBy}`}
                style={{ width: 350, marginBottom: 20 }}
              />

              <CheckPicker
                value={selectedhsn}
                onChange={handleHSNChange}
                data={hsndata}
                placement="autoVerticalStart"
                placeholder={`${label[0]?.attributes.HSN}`}
                style={{ width: 350, marginBottom: 20 }}
                // onOpen={fetchData6}
              />
            </Stack>
          </Drawer.Body>
        </Drawer>

        <Modal size="md" open={openq} onClose={() => setOpenq(false)} backdrop="static">
          <Modal.Body>
            <b style={{ marginBottom: '10px' }}>Print Formats</b>
            <FlexboxGrid justify="start">
              <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{ marginBottom: '5px' }}>
                <Button
                  block
                  style={{ height: '25vh' }}
                  onClick={() => handleDownloadQR(action == 'View' ? maindata : selectedProducts)}
                  disabled={isQRLoading1}
                  loading={isQRLoading1}
                >
                  <img src={s2} style={{ width: '45%' }} />
                </Button>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button
                  block
                  style={{ height: '25vh' }}
                  onClick={() =>
                    handleDownloadQRDS1(action == 'View' ? maindata : selectedProducts, data1)
                  }
                  disabled={isQRLoading7}
                  loading={isQRLoading7}
                >
                  <img src={s11} style={{ width: '35%' }} />
                </Button>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button
                  block
                  style={{ height: '25vh' }}
                  onClick={() => handleDownloadQR2(action == 'View' ? maindata : selectedProducts)}
                  disabled={isQRLoading2}
                  loading={isQRLoading2}
                >
                  <img src={s3} style={{ width: '35%' }} />
                </Button>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button
                  block
                  style={{ height: '25vh' }}
                  onClick={() =>
                    handleDownloadQR3(action == 'View' ? maindata : selectedProducts, data1)
                  }
                  disabled={isQRLoading3}
                  loading={isQRLoading3}
                >
                  <img src={s4} style={{ width: '35%' }} />
                </Button>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button
                  block
                  style={{ height: '25vh' }}
                  onClick={() =>
                    handleDownloadQR4(action == 'View' ? maindata : selectedProducts, data1)
                  }
                  disabled={isQRLoading4}
                  loading={isQRLoading4}
                >
                  <img src={s4} style={{ width: '35%' }} />
                </Button>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button
                  block
                  style={{ height: '25vh' }}
                  onClick={() =>
                    handleDownloadQR5(action == 'View' ? maindata : selectedProducts, data1)
                  }
                  disabled={isQRLoading5}
                  loading={isQRLoading5}
                >
                  <img src={s4} style={{ width: '35%' }} />
                </Button>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button
                  block
                  style={{ height: '25vh' }}
                  onClick={() =>
                    handleDownloadQR6(action == 'View' ? maindata : selectedProducts, data1)
                  }
                  disabled={isQRLoading6}
                  loading={isQRLoading6}
                >
                  <img src={s4} style={{ width: '35%' }} />
                </Button>
              </FlexboxGrid.Item>
              {/* <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button block style={{ height: '18vh' }}>
                  <img src={s1} style={{ width: '74%' }} />
                </Button>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Button block style={{ height: '18vh' }}>
                  <img src={s4} style={{ width: '29%' }} />
                </Button>
              </FlexboxGrid.Item> */}
            </FlexboxGrid>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={submitwithqr} appearance="primary" color="cyan">
              Done
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          size={window.innerWidth >= 746 ? 'full' : 'calc(100% - -7px)'}
          open={openp}
          onClose={handleClose}
        >
          <Modal.Header>
            <Modal.Title>
              <h5>Product Details</h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: '0px' }}>
            {modeldata?.map((item, index) => {
              return (
                <SwiperSlide key={item.id}>
                  <Grid fluid>
                    <Row>
                      <Col lg={12} xs={24} style={{ textAlign: '-webkit-center' }}>
                        <div
                          style={{}}
                          className="arrow arrow-left"
                          onClick={() => handlePrevImage(item)}
                        >
                          <Icon as={ArrowLeftIcon} />
                        </div>
                        <div className="imgp1" style={{ height: '400px', display: 'flex' }}>
                          <ReactImageMagnify
                            {...{
                              className: 'magnify',
                              imageStyle: { objectFit: 'contain' },
                              smallImage: {
                                alt: 'Wristwatch by Ted Baker London',
                                height: 400,
                                width: 400,
                                className: 'magnify',
                                // isFluidWidth: true,

                                src:
                                  selectedImagePath.url && selectedImagePath.id == item.id
                                    ? `${globalIP}${selectedImagePath.url}`
                                    : `${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`
                              },
                              largeImage: {
                                src:
                                  selectedImagePath.url && selectedImagePath.id == item.id
                                    ? `${globalIP}${selectedImagePath.url}`
                                    : `${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`,
                                width: calcwidth,
                                height: 1200
                              },
                              isHintEnabled: true,
                              enlargedImagePosition: 'beside',
                              enlargedImageContainerDimensions: { width: 700, height: 500 }
                            }}
                          />
                        </div>
                        <div
                          style={{}}
                          className="arrow1 arrow-right"
                          onClick={() => handleNextImage(item)}
                        >
                          <Icon as={ArrowRightIcon} />
                        </div>
                        {!item.attributes.MultipleImage.data && (
                          <div style={{ padding: '15px 50px' }}>
                            <Swiper
                              spaceBetween={20}
                              navigation={true}
                              slidesPerView={window.innerWidth >= 746 ? 6 : 3}
                              pagination={{ clickable: true }}
                              modules={[Navigation]}
                              className="nestedSwiper"
                            >
                              <SwiperSlide>
                                <div
                                  style={{
                                    height: '80px',
                                    borderRadius: ' 5px',
                                    overflow: 'hidden',
                                    objectFit: 'contain'
                                  }}
                                >
                                  <img
                                    src={`${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
                                    alt=""
                                    style={{
                                      width: '100%',
                                      objectFit: 'contain',
                                      height: '100%'
                                    }}
                                    onClick={() =>
                                      setSelectedImagePath({
                                        url: item?.attributes?.CoverImage?.data?.attributes?.url,
                                        id: item.id,
                                        default: true
                                      })
                                    }
                                  />
                                </div>
                              </SwiperSlide>
                            </Swiper>
                          </div>
                        )}
                        {item.attributes.MultipleImage.data && (
                          <div style={{ padding: '15px 10px' }}>
                            <Swiper
                              spaceBetween={20}
                              navigation={true}
                              slidesPerView={window.innerWidth >= 746 ? 6 : 3}
                              pagination={{ clickable: true }}
                              modules={[Navigation]}
                              className="nestedSwiper"
                            >
                              <SwiperSlide>
                                <div
                                  style={{
                                    height: '80px',
                                    borderRadius: '5px',
                                    objectFit: 'contain',

                                    overflow: 'hidden'
                                  }}
                                  className={
                                    selectedImagePath.url ==
                                      item?.attributes?.CoverImage?.data?.attributes?.url &&
                                    selectedImagePath.id == item.id
                                      ? 'image-product-select image-product-select-active'
                                      : null
                                  }
                                >
                                  <img
                                    src={`${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
                                    alt=""
                                    style={{
                                      width: '100%',
                                      objectFit: 'contain',
                                      height: '100%'
                                    }}
                                    onClick={() =>
                                      setSelectedImagePath({
                                        url: item?.attributes?.CoverImage?.data?.attributes?.url,
                                        id: item.id,
                                        default: true
                                      })
                                    }
                                  />
                                </div>
                              </SwiperSlide>
                              {item.attributes.MultipleImage.data &&
                                item.attributes.MultipleImage.data.map(multiImage => {
                                  return (
                                    <SwiperSlide key={multiImage.id}>
                                      <div
                                        style={{
                                          height: '80px',
                                          borderRadius: '5px',
                                          objectFit: 'contain',

                                          overflow: 'hidden'
                                        }}
                                        className={
                                          selectedImagePath.url == multiImage.attributes.url &&
                                          selectedImagePath.id == item.id
                                            ? 'image-product-select image-product-select-active'
                                            : null
                                        }
                                      >
                                        <img
                                          src={`${globalIP}${multiImage.attributes.url}`}
                                          alt=""
                                          style={{
                                            width: '100%',
                                            objectFit: 'contain',
                                            height: '100%'
                                          }}
                                          onClick={() =>
                                            setSelectedImagePath({
                                              url: multiImage.attributes.url,
                                              id: item.id,
                                              default: true
                                            })
                                          }
                                        />
                                      </div>
                                    </SwiperSlide>
                                  );
                                })}
                            </Swiper>
                          </div>
                        )}
                      </Col>
                      <Col lg={12} xs={24}>
                        <div
                          style={{ padding: '10px 20px', marginTop: '-14px' }}
                          className="slide-product-table"
                        >
                          <Stack justifyContent="space-between">
                            <div className="slide-product-name roboto-medium">
                              {item.attributes.ProductName}
                            </div>
                            <Stack direction="column" alignItems="flex-start">
                              <div>Cost(INR): {productCosts[item.id]?.totalinr || 0}</div>
                              <div>
                                Cost({item.attributes.SellingPriceCurrency}):{' '}
                                {productCosts[item.id]?.targetcostUSD || 0}
                              </div>
                              <div>SalePrice(INR): {item.attributes.ProductCost}</div>
                              <div>
                                Cost({item.attributes.SellingPriceCurrency}):{' '}
                                {item.attributes.SellingPrice}
                              </div>
                            </Stack>
                          </Stack>
                          <div className="slide-product-details ">
                            <span className="roboto-medium">Description</span>
                            <p className="roboto-regular">{item.attributes.Description}</p>
                          </div>
                          <Divider className="divide dvd" />

                          {!sizeshow && (
                            <div className="slide-product-dimensions">
                              <div style={{ display: 'flex', alignItems: 'center' }}></div>

                              {item.attributes.SetStatus !== 'Set' && (
                                <div>
                                  <span
                                    className="roboto-medium"
                                    style={{ display: 'flex', alignItems: 'center' }}
                                  >
                                    <p style={{ marginLeft: '0rem', color: '#005c80' }}>LxWxH</p>
                                    <SelectPicker
                                      data={unitOptions}
                                      searchable={false}
                                      defaultValue={selectedUnit}
                                      onChange={handleSizeChange}
                                      size="sm"
                                      cleanable={false}
                                    />
                                  </span>
                                  <p>
                                    {data11[0]?.Length.toFixed(2)} x {data11[0]?.Width.toFixed(2)} x{' '}
                                    {data11[0]?.Height.toFixed(2)} {selectedUnit}
                                  </p>
                                </div>
                              )}
                              <p className="roboto-regular">
                                {(() => {
                                  const isSet = item.attributes.SetStatus === 'Set';

                                  if (isSet) {
                                    const { dimensions, unit } = convertDimensions(
                                      item.attributes.SetSizes.map(({ Length, Width, Height }) => ({
                                        Length,
                                        Width,
                                        Height
                                      })),
                                      item.attributes.SizeUnit
                                      // sizeUnit
                                    );

                                    return (
                                      <Table
                                        height={180}
                                        width={550}
                                        data={data11}
                                        onRowClick={rowData => {
                                          // console.log(rowData);
                                        }}
                                        bordered
                                        cellBordered
                                        wordWrap="break-word"
                                        rowHeight={20}
                                      >
                                        <Column width={120} fixed align="center">
                                          <HeaderCell align="center">
                                            <b>Part Desc.</b>
                                          </HeaderCell>
                                          <Cell dataKey="Description" />
                                        </Column>

                                        <Column width={250} align="center">
                                          <HeaderCell style={{ marginTop: '-4px' }} align="center">
                                            <b>LxWxH</b>
                                            <SelectPicker
                                              data={unitOptions}
                                              searchable={false}
                                              value={selectedUnit}
                                              onChange={handleSizeChange}
                                              size="xs"
                                              cleanable={false}
                                              style={{ marginLeft: '8px' }}
                                            />
                                          </HeaderCell>
                                          <Cell>
                                            {rowData =>
                                              `${rowData.Length.toFixed(2) || 0}x${
                                                rowData.Width.toFixed(2) || 0
                                              }x${rowData.Height.toFixed(2) || 0} ${
                                                rowData.SizeUnit
                                              }`
                                            }
                                          </Cell>
                                        </Column>

                                        <Column width={100} align="center">
                                          <HeaderCell>
                                            <b>{label[0]?.attributes.NetWgt}</b>
                                          </HeaderCell>
                                          <Cell dataKey="NetWt" />
                                        </Column>

                                        <Column width={100} align="center" align="center">
                                          <HeaderCell>
                                            <b>{label[0]?.attributes.color}</b>
                                          </HeaderCell>
                                          <Cell dataKey="ColorName" />
                                        </Column>
                                        {finShow && (
                                          <>
                                            <Column width={120} align="center">
                                              <HeaderCell>
                                                <b>Finish</b>
                                              </HeaderCell>
                                              <Cell dataKey="FinishName" />
                                            </Column>

                                            <Column width={150} align="center">
                                              <HeaderCell>
                                                <b>Mat. Name</b>
                                              </HeaderCell>
                                              <Cell dataKey="MatName" />
                                            </Column>
                                          </>
                                        )}
                                      </Table>
                                    );
                                  }
                                })()}
                              </p>
                            </div>
                          )}
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">Set Status</div>
                            <div>{item.attributes.SetStatus}</div>
                          </div>
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">
                              {attributesName?.AliasCode || 'Alias Code'}
                            </div>
                            <div>{item.attributes.ProductId}</div>
                          </div>
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">
                              {attributesName?.Category || 'Category'}
                            </div>
                            <div>{item.attributes.CategoryName}</div>
                          </div>
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">
                              {attributesName?.ProductType || 'Product Type'}
                            </div>
                            <div>{item.attributes.ProductTypeName}</div>
                          </div>
                          {item.attributes.SetStatus !== 'Set' && (
                            <div className="slide-product-Alias ">
                              <div className="roboto-medium">
                                {attributesName?.finish || 'Finish'}
                              </div>
                              <div>{item.attributes.FinishName}</div>
                            </div>
                          )}
                          {item.attributes.SetStatus !== 'Set' && (
                            <div className="slide-product-Alias ">
                              <div className="roboto-medium">
                                {attributesName?.color || 'Color'}
                              </div>
                              <div>{item.attributes.ColorName}</div>
                            </div>
                          )}
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">{attributesName?.cbm || 'CBM'}</div>
                            <div>{item.attributes.Total_CBM}</div>
                          </div>
                          {sizeshow && (
                            <div className="slide-product-Alias ">
                              <div className="roboto-medium">
                                {attributesName?.SizeRange || 'Free Size'}
                              </div>
                              <div>{item.attributes.SizeRange}</div>
                            </div>
                          )}
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">
                              {attributesName?.GrossWgt || 'Gross Weight'}
                            </div>
                            <div>{item.attributes.GrossWeight}</div>
                          </div>
                          <div className="slide-product-Alias ">
                            <div className="roboto-medium">
                              {attributesName?.NetWgt || 'Net Weight'}
                            </div>
                            <div>{item.attributes.NetWeight}</div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Grid>
                </SwiperSlide>
              );
            })}
          </Modal.Body>
        </Modal>
      </Container>
      {open && (
        <ModalComponent
          open={open}
          onClose={() => {
            setOpen(false);
            setCurrentPage(1); // ✅ Reset page
            setData123([]);
            fetchDataFair();
          }}
          fairdata={fairdata}
          fairStatuses={fairStatuses}
          fairmeta={fairmeta}
          setFairData={setFairData}
          fetchDataEnc={fetchDataEnc}
        />
      )}
    </>
  );
};

export default ManageFair;
